// @ts-nocheck
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import _ from 'lodash';
import { useLocation, Link, useParams, useOutletContext, useSearchParams, useNavigate } from 'react-router-dom';
import { Ellipsis } from  'lucide-react'
import {
  ChevronDown,
  ChevronUp,
  DownloadCloudIcon,
  MoreVertical,
  Settings,
  AlertCircle, CheckCircle2, Clock,
  X, FilterX, RotateCcw, Code2,
  Pencil, Copy, Trash2,
} from 'lucide-react';
import ConfirmDeleteDialog from '@/components/ConfirmDeleteDialog';
import CloneRegistrationModal from '@/components/CloneRegistrationModal';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { useAuth } from '@/auth/clerkShim';
import DiscountCodesCard from './DiscountCodesCard';
import moment from 'moment';
import Papa from 'papaparse';
// import Button from '@mui/material/Button';

// import { SelectValue, SelectTrigger, SelectItem, SelectContent, Select } from "@/components/ui/select"
import { TableHead, TableRow, TableHeader, TableCell, TableBody, Table } from "@/components/ui/table"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import MoveTeamEligibilityDialog from "@/components/MoveTeamEligibilityDialog";
import { useToast } from "@/components/ui/use-toast"
import { toast as sonnerToast } from "sonner"
import { Checkbox } from "@/components/ui/checkbox"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuCheckboxItem,
} from "@/components/ui/dropdown-menu";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"; // Add these imports
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { PageContainer, PageHeader } from '@/components/Page/PageContainer';
import helpers from '@/utils/helpers';
import { downloadReleaseStatement } from '@/utils/printReleaseStatement';
import EmbedCodeModal from '@/components/EmbedCodeModal/EmbedCodeModal';
import { buildUserProfileMaps, resolveUserProfile, normEmail } from '@/utils/userProfileLookup';
// import './styles.css'; // Ensure the path to the CSS file is correct

// Import Zustand store hooks
import useRegistrationStore from '@store/registrationStore';
import usePaymentProductStore from '@store/paymentProductStore';
import useRegistrationTeamStore from '@store/registrationTeamStore';
import useTournamentStore from '@store/tournamentStore';
import useLeagueStore from '@store/leagueStore';
import useTeamDivisionStore from '@/store/teamDivisionStore';
import usePlayerStore from '@store/playerStore';
import usePaymentStore from '@/store/paymentStore';
import useDivisionStore from '@store/divisionStore';
import useUserProfileStore from '@store/userProfileStore';
import { DEFAULT_MANAGER_FIELDS } from '@/constants/defaults';
import { Switch } from "@/components/ui/switch"
import { Label } from "@/components/ui/label"
import { IconButton } from '@mui/material';
import getTeamDisplayName from '@staty/shared/utils/getTeamDisplayName';
import isAutoGeneratedTeamName from '@staty/shared/utils/isAutoGeneratedTeamName';
import {
  getPlayerWaiverStatus,
  calculatePaymentDue,
  calculateTotalPaymentMade,
  getPaymentStatus as getPaymentStatusShared,
} from '@staty/shared/utils/registrationStatus';
import { getWaitlistPosition } from '@staty/shared/utils/registrationCapacity';
import {
  getCapacityState,
  getRegistrationTeamsForDivision,
  getDivisionCapacityCounts,
} from '@staty/shared/utils/waitlist';
import {
  REGISTRATION_TEAM_STATUS_OPTIONS,
  normalizeStatus,
  getStatusLabel,
  isAccepted,
  toSelectValue,
  fromSelectValue,
} from '@staty/shared/utils/registrationTeamStatus';
import { cn } from '@/lib/utils';
import { entityLabel, isDeletedEntity } from '@/utils/entityLabel';
import { buildDuplicateInfo } from './duplicateDetection';
import { deriveRegistrationCounts, teamsOccupyingDivision } from '@/utils/registrationCounts';

function RegistrationAdmin() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { registrationId } = useParams();
  const { getToken } = useAuth();
  const { toast } = useToast();
  const { leagueName = '' } = useOutletContext() as any;

  // Initialize state from URL params
  const [ selectedContest, setSelectedContest ]: any = useState(() => searchParams.get('format') || 'All');
  const [ selectedDivisions, setSelectedDivisions ]: any = useState(() => {
    const divisions = searchParams.get('divisions');
    return divisions ? divisions.split(',').filter(Boolean) : [];
  });
  const [ searchTerm, setSearchTerm ]: any = useState(() => searchParams.get('search') || '');

  const [deleteTeam, setDeleteTeam] = useState<boolean | "indeterminate">(true);
  const [refundingTeam, setRefundingTeam] = useState<any>(null);
  const [paymentFilter, setPaymentFilter] = useState(() => searchParams.get('paid') || "all");
  const [acceptanceFilter, setAcceptanceFilter] = useState(() => searchParams.get('accepted') || "all");
  const [refundAmount, setRefundAmount] = useState<number | null>(null);
  const [selectedPayments, setSelectedPayments] = useState<string[]>([]);
  const [selectedPayment, setSelectedPayment] = useState<string | null>(null);
  const [customRefundAmount, setCustomRefundAmount] = useState<number | null>(null);
  const [refundMethod, setRefundMethod] = useState<'manual' | 'payments'>('manual');
  const [removingTeam, setRemovingTeam] = useState<any>(null);
  const [consolidatingTeam, setConsolidatingTeam] = useState<any>(null);
  // Free-agent pool (ADR 0054): selection + "Assign to team…" dialog state.
  const [freeAgentsOpen, setFreeAgentsOpen] = useState(true);
  const [selectedFreeAgents, setSelectedFreeAgents] = useState<string[]>([]);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [assignDivisionId, setAssignDivisionId] = useState('');
  const [assignMode, setAssignMode] = useState<'existing' | 'new'>('existing');
  const [assignDivisionTeamId, setAssignDivisionTeamId] = useState('');
  const [assignNewTeamName, setAssignNewTeamName] = useState('');
  const [assigning, setAssigning] = useState(false);
  // Discreet "Deleted teams" restore section: default collapsed, lazy-loaded on open.
  const [deletedOpen, setDeletedOpen] = useState(false);
  const [deletedLoaded, setDeletedLoaded] = useState(false);
  const [restoringTeam, setRestoringTeam] = useState<any>(null);
  const [isConsolidating, setIsConsolidating] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showEmbedModal, setShowEmbedModal] = useState(false);
  const [registrationSettings, setRegistrationSettings] = useState<any>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState<any>(null);
  const [popoverTrigger, setPopoverTrigger] = useState<HTMLElement | null>(null);
  const [teamNameSort, setTeamNameSort] = useState<'asc' | 'desc' | null>(null);
  const [createdSort, setCreatedSort] = useState<'asc' | 'desc' | null>(null);

  // Access state and actions from Zustand store
  const { registrations, getRegistrationById, updateRegistration, updateRegistrationSettings, deleteRegistration } = useRegistrationStore((state: any) => ({
    registrations: state.registrations,
    getRegistrationById: state.getRegistrationById,
    updateRegistration: state.updateRegistration(getToken),
    updateRegistrationSettings: state.updateRegistrationSettings(getToken),
    deleteRegistration: state.deleteRegistration(getToken),
  }));
  // Registration-level destructive/clone actions (header ⋯ menu).
  const [showDeleteRegistration, setShowDeleteRegistration] = useState(false);
  const [deletingRegistration, setDeletingRegistration] = useState(false);
  const [showCloneRegistration, setShowCloneRegistration] = useState(false);

  const { paymentProducts, getPaymentProductsByLeagueName } = usePaymentProductStore((state: any) => ({
    paymentProducts: state.paymentProducts,
    getPaymentProductsByLeagueName: state.getPaymentProductsByLeagueName(getToken),
  }));

  // const { seasons, getContestsByTournamentId, getSeasonById } = useLeagueStore((state: any) => ({
  //   seasons: state.seasons,
  //   getContestsByTournamentId: state.getContestsByTournamentId,
  //   getSeasonById: state.getSeasonById,
  // }));

  const { players, getPlayersByRegistrationId } = usePlayerStore((state: any) => ({
    players: state.players,
    getPlayersByRegistrationId: state.getPlayersByRegistrationId,
  }));

  const { teamDivisions, getTeamDivisionsByRegistrationId } = useTeamDivisionStore((state: any) => ({
    teamDivisions: state.teamDivisions,
    getTeamDivisionsByRegistrationId: state.getTeamDivisionsByRegistrationId,
  }));

  const { registrationTeams, deletedRegistrationTeams, getRegistrationTeamsByRegistrationId, getDeletedTeams, restoreTeam, updateTeamRegistration, updateTeamStatus, removeTeamRegistration, consolidateTeam, checkDivisionEligibility, assignFreeAgents } = useRegistrationTeamStore((state: any) => ({
    registrationTeams: state.registrationTeams,
    deletedRegistrationTeams: state.deletedRegistrationTeams,
    getRegistrationTeamsByRegistrationId: state.getRegistrationTeamsByRegistrationId,
    getDeletedTeams: state.getDeletedTeams,
    restoreTeam: state.restoreTeam(getToken),
    updateTeamRegistration: state.updateTeamRegistration,
    updateTeamStatus: state.updateTeamStatus,
    removeTeamRegistration: state.removeTeamRegistration(getToken),
    consolidateTeam: state.consolidateTeam(getToken),
    checkDivisionEligibility: state.checkDivisionEligibility,
    assignFreeAgents: state.assignFreeAgents(getToken),
  }));

  // Pending division move awaiting an eligibility-override decision.
  const [pendingDivisionMove, setPendingDivisionMove] = useState<any>(null);

  const { payments, paymentPlans, getPaymentsByRegistrationId, getPaymentPlansByRegistrationId, refundPaymentByRegistrationTeamId, refundPaymentByPaymentIntentId  } = usePaymentStore((state: any) => ({
    payments: state.payments,
    paymentPlans: state.paymentPlans,
    getPaymentsByRegistrationId: state.getPaymentsByRegistrationId,
    getPaymentPlansByRegistrationId: state.getPaymentPlansByRegistrationId,
    refundPaymentByRegistrationTeamId: state.refundPaymentByRegistrationTeamId(getToken),
    refundPaymentByPaymentIntentId: state.refundPaymentByPaymentIntentId(getToken),
  }));

  const { allDivisions, getDivisionsByRegistrationId } = useDivisionStore((state: any) => ({
    allDivisions: state.divisions,
    getDivisionsByRegistrationId: state.getDivisionsByRegistrationId,
  }));

  const { userProfiles, profileFields, getUserProfilesByOrganization } = useUserProfileStore((state: any) => ({
    userProfiles: state.userProfiles,
    profileFields: state.profileFields,
    getUserProfilesByOrganization: state.getUserProfilesByOrganization,
  }));

  // Join players to org profiles by user id, falling back to email when a player
  // has no linked user (registered before the person had an account).
  const profileMaps = buildUserProfileMaps(userProfiles);
  const userProfileByUser = profileMaps.byUser;

  const registration = _.find(registrations, { _id: registrationId });
  const showCoaches = !!registration?.allowCoaches;

  // Scope the global divisionStore array down to divisions whose league is one
  // of this registration's contests. The store is shared across pages, so
  // entries from prior fetches stick around — without this filter we'd leak
  // other registrations' divisions into this page.
  const contestIds = _.map(_.get(registration, 'contests', []), (c) => String(c?._id || c));
  const registrationDivisions = _.filter(allDivisions, (division) => {
    const leagueId = String(_.get(division, 'league._id') || _.get(division, 'league'));
    return contestIds.includes(leagueId);
  });

  // Match /admin/organize's division order exactly: first by parent league/format
  // order (League.priority asc, then name), then by division priority desc + name
  // within each format. Composing organize's two orderBy calls (OrganizeAdmin.tsx
  // leagues ['priority','name'],['asc','asc'] + divisions ['priority','name'],
  // ['desc','asc']) keeps the ordering — incl. undefined handling — identical.
  const filteredDivisions = _.filter(registrationDivisions, (division) => {
    const leagueId = String(_.get(division, 'league._id') || _.get(division, 'league'));
    return selectedContest === 'All' || leagueId === selectedContest;
  });
  const orderedLeagues = _.orderBy(_.get(registration, 'contests', []), ['priority', 'name'], ['asc', 'asc']);
  const sortDivisionsWithinLeague = (divs) => _.orderBy(divs, ['priority', 'name'], ['desc', 'asc']);
  const divisionsByLeague = _.groupBy(filteredDivisions, (d) => String(_.get(d, 'league._id') || _.get(d, 'league')));
  const divisions = [
    ..._.flatMap(orderedLeagues, (league) => sortDivisionsWithinLeague(divisionsByLeague[String(league._id)] || [])),
    // Defensive: any division whose parent league isn't in registration.contests
    // (shouldn't happen — registrationDivisions is pre-filtered by contestIds) is
    // appended last so nothing silently disappears.
    ...sortDivisionsWithinLeague(
      _.filter(filteredDivisions, (d) => {
        const leagueId = String(_.get(d, 'league._id') || _.get(d, 'league'));
        return !_.some(orderedLeagues, (l) => String(l._id) === leagueId);
      }),
    ),
  ];

  const playersWithInfo = _.filter(players, (player) => {
    return _.get(player, 'info.first_name') && _.get(player, 'info.last_name');
  });

  // Search matching for a team. The box searches team name + team/manager
  // emails (rank 0), plus each roster player's name AND email (rank 1, lowest,
  // so a team matched only by a player sorts below team-name/email matches).
  // Whitespace-insensitive search: lowercase + collapse runs of whitespace to a
  // single space + trim, so stray/double spaces in stored names (e.g. a player
  // saved as "Wayne " / "Hamamoto ") don't break substring matching of a
  // single-spaced query like "Wayne H".
  const normalizeSearchText = (s) => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();

  // registrationTeam id -> space-joined lowercased player names (from the
  // players store, built once).
  const playerNamesByTeam = _.reduce(playersWithInfo, (acc, p) => {
    const key = String(helpers.getObjId(_.get(p, 'registrationTeam')) || '');
    if (!key) return acc;
    const name = normalizeSearchText(`${_.get(p, 'info.first_name', '')} ${_.get(p, 'info.last_name', '')}`);
    acc[key] = acc[key] ? `${acc[key]} ${name}` : name;
    return acc;
  }, {});

  // Normalized name + email haystack for a team's embedded roster players
  // (registrationTeam.players[].info.{first_name,last_name,email}). This is what
  // makes a player's email (e.g. "Kmleong@cox.net") searchable — the store map
  // above only carries names.
  const embeddedPlayerText = (team) =>
    normalizeSearchText(
      (_.get(team, 'players', []) || [])
        .map((p) =>
          `${_.get(p, 'info.first_name', '')} ${_.get(p, 'info.last_name', '')} ${_.get(p, 'info.email', '')}`,
        )
        .join(' '),
    );

  // 0 = matches team name or a team/manager email (highest); 1 = matches ONLY a
  // roster player's name or email (lowest); -1 = no match. Empty term => 0 for
  // all (no reordering).
  const teamSearchRank = (team) => {
    const term = normalizeSearchText(searchTerm);
    if (!term) return 0;
    const nameEmail =
      normalizeSearchText(_.get(team, 'teamName', '')).includes(term) ||
      normalizeSearchText(_.get(team, 'teamManager[0].email', '')).includes(term) ||
      normalizeSearchText(_.get(team, 'teamManager[1].email', '')).includes(term) ||
      normalizeSearchText(_.get(team, 'user.email', '')).includes(term);
    if (nameEmail) return 0;
    const playerMatch =
      (playerNamesByTeam[String(team._id)] || '').includes(term) ||
      embeddedPlayerText(team).includes(term);
    if (playerMatch) return 1;
    return -1;
  };
  const matchesTeamSearch = (team) => teamSearchRank(team) >= 0;

  // Helper to get team display name using divisionTeam's players
  const getDisplayNameForRegistrationTeam = (registrationTeam) => {
    const divisionTeam = _.find(teamDivisions, (dt) => 
      helpers.getObjId(dt.registrationTeam) === registrationTeam._id
    );
    if (divisionTeam) {
      return getTeamDisplayName(divisionTeam);
    }
    // Fallback to raw teamName if no divisionTeam found
    return registrationTeam.teamName || 'Unknown Team';
  };

  // Free-agent partition (ADR 0054). Free agents are RegistrationTeams with
  // isFreeAgent: true, arriving in the same findAllByRegistrationId payload.
  // They live in their own pool section — ALL of them (pool + placed) are
  // excluded from the teams grid and everything derived from it (counts,
  // capacity chips, CSV, duplicate detection).
  const freeAgentTeams = _.filter(registrationTeams, (rt) =>
    rt.isFreeAgent && helpers.getObjId(rt.registration) === registrationId);
  // Pool = awaiting placement; placed = assigned to a DivisionTeam (the assign
  // endpoint stamps status 'accepted' — isAccepted also folds legacy values).
  const freeAgentPool = _.filter(freeAgentTeams, (rt) => !isAccepted(rt));
  const placedFreeAgents = _.filter(freeAgentTeams, (rt) => isAccepted(rt));

  const filteredRegisteredBySeason = _.chain(registrationTeams)
    // Scope to THIS registration's teams so a multi-registration store can't
    // bleed other registrations' teams into a division's capacity tally.
    .filter((team) => helpers.getObjId(team.registration) === registrationId)
    // Free agents never render in the teams grid nor hold a division seat —
    // they live in the "Free Agents" pool section below the grid (ADR 0054).
    .filter((rt) => !rt.isFreeAgent)
    .filter((rt) => {
    if (selectedContest === 'All') return true;
    const contest = _.get(rt, 'contest._id') || _.get(rt, 'requestedContest._id');
    return contest === selectedContest;
  })
  .value();

  // All filters except selectedDivisions — used for division counts so clicking a division
  // doesn't zero out the other divisions' counts.
  const registeredFiltered = _.chain(filteredRegisteredBySeason)
    .filter((team) => {
      return helpers.getObjId(team.registration) === registrationId;
    })
    .filter((team) => {
      if (paymentFilter === 'paid') {
        // "Partial Paid": only teams with an incomplete payment (0 < made < due),
        // matching the Payment Status column. Excludes fully-paid / overpaid /
        // manually-paid teams (the old `+paid > 0` matched those too).
        const due = Number(calculateTotalPayments2(team, true, team.players || []));
        const made = Number(getTotalPaymentMade(team, true));
        const status = getPaymentStatusShared(due, made, team.hasPaid);
        return status === 'partial';
      } else if (paymentFilter === 'fully_paid') {
        const due = Number(calculateTotalPayments2(team, true, team.players || []));
        const made = Number(getTotalPaymentMade(team, true));
        const status = getPaymentStatusShared(due, made, team.hasPaid);
        return status === 'paid' || status === 'overpaid' || status === 'paid_manually';
      } else if (paymentFilter === 'unpaid') {
        const paid = filterPaymentsByRegistrationId({ registrationTeamId: team._id , donation: false, raw: true })
        return +paid === 0 && !team.hasPaid;
      } else {
        return true;
      }
    })
    .filter((team) => {
      // Via isAccepted(), never a raw `team.status` comparison: the retired
      // /admin app wrote the legacy value 'accept', which normalizeStatus folds
      // to 'accepted' but a string compare does not — those teams were being
      // misfiled under "Not Accepted" and missing from "Accepted".
      if (acceptanceFilter === 'accepted') {
        return isAccepted(team);
      } else if (acceptanceFilter === 'not-accepted') {
        return !isAccepted(team);
      } else {
        return true;
      }
    })
    .filter(matchesTeamSearch)
    .value();

  /**
   * The Division filter, in one place — it is applied at three stages (the base
   * list, the counted list, and the rendered page range) and they must agree.
   *
   * Two kinds of team ALWAYS show, whatever is filtered:
   *  - Unassigned (no division at all), so an admin can find them and assign one
   *    via the row's dropdown.
   *  - Stranded on a SOFT-DELETED division. Deleting a division doesn't cascade,
   *    so the team keeps pointing at the tombstone — but the filter chips are
   *    built from LIVE divisions only, so that division can never be selected.
   *    Without this they'd vanish under any active filter and be unreachable for
   *    reassignment, which is exactly the state that needs fixing most.
   */
  const matchesDivisionFilter = (rt: any) => {
    if (selectedDivisions.length === 0) return true;
    const divisionEntity = _.get(rt, 'division') || _.get(rt, 'requestedDivision');
    const divisionId = _.get(divisionEntity, '_id');
    if (!divisionId || isDeletedEntity(divisionEntity)) return true;
    return selectedDivisions.includes(divisionId);
  };

  const registered = _.chain(registeredFiltered)
    .filter(matchesDivisionFilter)
    .value();

  const [showRegistration, setShowRegistration] = useState(false);

  // Client-side duplicate detection — extracted to duplicateDetection.ts so the
  // free-agent exclusion (ADR 0054) is unit-testable. Maps each duplicate team
  // → its group + the earliest-created survivor, so the ⋮ menu can offer
  // "Consolidate" only where a duplicate actually exists.
  const duplicateInfoByTeamId = useMemo(() => buildDuplicateInfo(registrationTeams), [registrationTeams]);

  const showRegistrationForm = () => {
    setShowRegistration(true);
  }

  const onContestChange = (value) => {
    console.log('onContestChange::value::', value);
    setSelectedContest(value);
    // setSelectedDivision('All');
    setSelectedDivisions([]);
    if (value === 'All') {
      setSelectedDivisions([]);
    }
  }

  // const onDivisionChange = (value) => {
  //   console.log('onDivisionChange::value::', value);
  //   setSelectedDivisions([value]);
  // }

  const onToggleDivision = (value) => {
    console.log('onToggleDivision::value::', value, selectedDivisions);
    setCurrentPage(1);
    if (selectedDivisions.includes(value)) {
      setSelectedDivisions(_.filter(selectedDivisions, (division) => division !== value));
    } else {
      setSelectedDivisions([...selectedDivisions, value]);
    }
    // setSelectedDivisions(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value,
    // );
  }

  // The Status dropdown's single writer. Confirms only for the two values that
  // have consequences beyond a label — Withdrawn hides the team from every
  // public surface, Waitlist overrides the payment/first-come order.
  const handleStatusSelect = async (status, teamRegistration) => {
    const name = getDisplayNameForRegistrationTeam(teamRegistration);
    const label = getStatusLabel(status);
    if (status === 'withdrawn') {
      const ok = window.confirm(
        `Mark ${name} as Withdrawn?\n\nTheir spot is freed and they're hidden from the public site and from division counts. They stay on this page, still counted as a registration, and keeping any payments. You can set them back at any time.`,
      );
      if (!ok) return;
    } else if (status === 'waitlisted') {
      const ok = window.confirm(
        `Force ${name} onto the waitlist?\n\nThis overrides the normal first-come/paid order and frees their spot for the next team.`,
      );
      if (!ok) return;
    }
    const token = await getToken();
    await updateTeamStatus(teamRegistration._id, status, token, (res) => {
      toast({ description: `${getDisplayNameForRegistrationTeam(res)} set to ${label}` });
    });
    // The status change may have promoted another team off the waitlist, so
    // refresh the whole list rather than just the edited row.
    await async_getRegistrationTeamsByRegistrationId(registrationId);
  };

  const handleRefundTeam = async (team) => {
    try {
      const token = await getToken();
      let amountToRefund = 0;
      const organization = _.get(registration, 'organization');

      // Process selected payment
      if (selectedPayment && refundMethod === 'payments') {
        const teamPayments = getTeamPayments(team._id);

        if (selectedPayment === 'full') {
          for (const payment of teamPayments) {
            await refundPaymentByPaymentIntentId(
              payment.stripe_payment_intent,
              payment.totalAmount,
              helpers.getObjId(organization)
            );
            amountToRefund += payment.totalAmount;
          }
        } else {
          const payment = _.find(teamPayments, { stripe_payment_intent: selectedPayment });
          amountToRefund = _.get(payment, 'totalAmount', 0); // already in cents
          await refundPaymentByPaymentIntentId(selectedPayment, amountToRefund, helpers.getObjId(organization));
        }
      }

      // Process custom refund amount
      if (customRefundAmount && customRefundAmount > 0 && refundMethod === 'manual') {
         amountToRefund += customRefundAmount * 100; // Convert dollars to cents
         await refundPaymentByRegistrationTeamId(team._id, customRefundAmount * 100, helpers.getObjId(organization), selectedPayment);
      }
      if (amountToRefund > 0) {
        toast({
          description: `${getDisplayNameForRegistrationTeam(team)} has been refunded ${convertToUSD(amountToRefund)} successfully`,
        });
      }

      // Reset state without affecting each other
      setRefundingTeam(null);
      setRefundAmount(null);
      setSelectedPayment(null);
      setCustomRefundAmount(null);
    } catch (error) {
      toast({
        variant: "destructive",
        description: "Failed to process refund. Please try again.",
      });
    }
  };

  const getTeamPayments = (teamId: string) => {
    // Filter payments for the specific team and exclude donations
    const teamPayments = payments.filter(payment => 
      payment.registrationTeam === teamId && !payment.donation
    );
  
    // Group payments by stripe_payment_intent
    const groupedPayments = _.groupBy(teamPayments, 'stripe_payment_intent');
  
    // Consolidate amounts and capture the initial paidDate within each group
    const consolidatedPayments = _.map(groupedPayments, (group, stripe_payment_intent) => {
      const totalAmount = _.sumBy(group, 'amount'); // Sum total amount, can be negative
  
      // Find the earliest paidDate in the group
      const initialPaidDate = _.minBy(group, payment => new Date(payment.paidDate))?.paidDate;
  
      return {
        stripe_payment_intent,
        totalAmount,
        initialPaidDate, // Added initial paidDate
      };
    }).filter(payment => payment.totalAmount !== 0); // Optional: Remove payments with zero total
  
    return consolidatedPayments;
  };

  const refundTeam = async (teamRegistration) => {
    // TODO: Implement refund team by finding the payment intent id and then calling the refund payment by payment intent id
    const teamPayments = getTeamPayments(teamRegistration._id);
    if (teamPayments.length === 0) {
      toast({
        variant: "destructive",
        description: "No payments found for team",
      });
      return;
    }
    setRefundingTeam(teamRegistration);
  }

  const onDivisionChange2 = (value) => {
    console.log('onDivisionChange2::value::', value);
    setSelectedDivisions(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  }

  const async_getPaymentsByRegistrationId = async (registrationId) => {
    const token = await getToken();
    await getPaymentsByRegistrationId(registrationId, token);
    // INT-0018: installment plans ride along with payments (badges on rows).
    await getPaymentPlansByRegistrationId(registrationId, token);
  };

  const async_getRegistrationTeamsByRegistrationId = async (registrationId) => {
    const token = await getToken();
    await getRegistrationTeamsByRegistrationId(registrationId, token);
  }

  const async_getTeamDivisionsByRegistrationId = async (registrationId) => {
    const token = await getToken();
    await getTeamDivisionsByRegistrationId(registrationId, token);
  }

  const async_getPlayersByRegistrationId = async (registrationId) => {
    await getPlayersByRegistrationId(registrationId);
  }

  const async_getPaymentProductsByLeagueName = async (leagueName) => {
    await getPaymentProductsByLeagueName(leagueName);
  }

  useEffect(() => {
    getRegistrationById(registrationId);
    getDivisionsByRegistrationId(registrationId);
    async_getRegistrationTeamsByRegistrationId(registrationId);
    async_getPaymentsByRegistrationId(registrationId);
    async_getPlayersByRegistrationId(registrationId);
    async_getTeamDivisionsByRegistrationId(registrationId);
    async_getPaymentProductsByLeagueName(leagueName);
    getUserProfilesByOrganization(leagueName);
    console.log('getRegistrationById');
  }, []);

  useEffect(() => {
    if (refundingTeam) {
      const paymentMade = filterPaymentsByRegistrationId({
        registrationTeamId: refundingTeam._id,
        donation: false,
        raw: true
      });
      setRefundAmount(Number(paymentMade) / 100); // Convert cents to dollars
      setSelectedPayments([]); // Reset selected payments
    }
  }, [refundingTeam]);

  // This is added to handle when there's only 1 season
  useEffect(() => {
    if (registration && registration.contests.length === 1) {
      // Only set if not already set from URL
      if (selectedContest === 'All' && !searchParams.get('format')) {
        setSelectedContest(registration.contests[0]._id);
      }
    }
  }, [registration]);

  // This is added to handle when there's only 1 division
  useEffect(() => {
    if (registration && registrationDivisions.length === 1) {
      // Only set if not already set from URL
      if (selectedDivisions.length === 0 && !searchParams.get('divisions')) {
        setSelectedDivisions([registrationDivisions[0]._id]);
      }
    }
  }, [registration, registrationDivisions, selectedContest]);

  // Sync filter state to URL params
  useEffect(() => {
    const params = new URLSearchParams();
    
    if (selectedContest && selectedContest !== 'All') {
      params.set('format', selectedContest);
    }
    if (selectedDivisions.length > 0) {
      params.set('divisions', selectedDivisions.join(','));
    }
    if (searchTerm) {
      params.set('search', searchTerm);
    }
    if (paymentFilter && paymentFilter !== 'all') {
      params.set('paid', paymentFilter);
    }
    if (acceptanceFilter && acceptanceFilter !== 'all') {
      params.set('accepted', acceptanceFilter);
    }

    const newSearch = params.toString();
    const currentSearch = searchParams.toString();
    
    // Only update if params actually changed to avoid unnecessary navigation
    if (newSearch !== currentSearch) {
      setSearchParams(params, { replace: true });
    }
  }, [selectedContest, selectedDivisions, searchTerm, paymentFilter, acceptanceFilter]);

  function convertToUSD (amount) {
    return (amount/100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }


  function filterPaymentsByRegistrationId({ registrationTeamId, donation, raw = false}) {
    let amount = 0;
    const foobar = _.filter(payments, { registrationTeam: registrationTeamId, donation });
    _.each(foobar, (payment) => {
      if ((payment.currency || 'usd').toLowerCase() === 'usd') {
        amount += payment.amount;
      } else {
        amount += Math.round(payment.amount * payment.currencyConversionRate);
      }
    });
    return raw ? amount : convertToUSD(amount);
  };

  function getTotalPaymentMade(team, raw = false) {
    const stripePayments = filterPaymentsByRegistrationId({ registrationTeamId: team._id, donation: false, raw: true });
    const totalAmount = calculateTotalPaymentMade(Number(stripePayments), team);
    return raw ? totalAmount : convertToUSD(totalAmount);
  }

  // Sum a single player's payments (players-pay-individually mode). Individual
  // player payments are linked to a player only via `metadata.playerEmail`
  // (+ registrationTeam); mirrors filterPaymentsByRegistrationId but keyed on
  // that email (case-insensitive). Amount is in cents.
  function getPlayerAmountPaid(team, playerEmail, raw = false) {
    let amount = 0;
    if (playerEmail) {
      const playerPayments = _.filter(payments, (p) =>
        p.registrationTeam === team._id &&
        !p.donation &&
        _.toLower(_.get(p, 'metadata.playerEmail', '')) === _.toLower(playerEmail)
      );
      _.each(playerPayments, (p) => {
        amount += (p.currency || 'usd').toLowerCase() === 'usd'
          ? p.amount
          : Math.round(p.amount * p.currencyConversionRate);
      });
    }
    return raw ? amount : convertToUSD(amount);
  }

  // Latest paidDate for a single player's payments (players-pay-individually),
  // matched via metadata.playerEmail like getPlayerAmountPaid. '' if none.
  function getPlayerPaymentDate(team, playerEmail) {
    if (!playerEmail) return '';
    const playerPayments = _.filter(payments, (p) =>
      p.registrationTeam === team._id &&
      !p.donation &&
      _.toLower(_.get(p, 'metadata.playerEmail', '')) === _.toLower(playerEmail)
    );
    const latest = _.maxBy(playerPayments, (p) => new Date(_.get(p, 'paidDate')).getTime());
    return latest ? moment(new Date(latest.paidDate)).format('MM/DD/YYYY h:mm A') : '';
  }

  // Human label for a resolved-cost discount code.
  function discountLabel(code) {
    switch (code) {
      case 'multiTeam': return 'Additional-team discount';
      case 'earlyBird': return 'Early-bird pricing';
      case 'lateRegistration': return 'Late registration';
      default: return '';
    }
  }

  // Resolve a payment's player email → the player's display name (from the
  // team's resolved per-player breakdown); falls back to the email itself.
  function playerNameByEmail(team, email) {
    if (!email) return '';
    const row = _.find(team?.resolvedCostByPlayer || [], (r) => _.toLower(r.email) === _.toLower(email));
    return _.get(row, 'name') || email;
  }

  // Who paid a Stripe payment (server-enriched from metadata.paidByUser, or the
  // Stripe customer details).
  function payerLabel(p) {
    return p.paidByName || p.payerName || p.paidByEmail || p.payerEmail || '—';
  }

  // Discount labels applicable to a payment: match the player (player-pay) in the
  // resolved breakdown, else the team-level discounts (team-pay).
  function discountsForPayment(team, email) {
    const row = email
      ? _.find(team?.resolvedCostByPlayer || [], (r) => _.toLower(r.email) === _.toLower(email))
      : null;
    const codes = _.get(row, 'appliedDiscounts') || (email ? [] : (team?.appliedDiscounts || []));
    return (codes || []).map(discountLabel).filter(Boolean);
  }

  function getPaymentBreakdown(team) {
    const stripePayments = _.filter(payments, { registrationTeam: team._id, donation: false });
    const breakdown = [];
    
    // Add stripe payments
    stripePayments.forEach(payment => {
      const amount = (payment.currency || 'usd').toLowerCase() === 'usd'
        ? payment.amount
        : Math.round(payment.amount * payment.currencyConversionRate);
      // `paidByName` is resolved server-side from metadata.paidByUser →
      // User.name (see paymentsByRegistration). Manual entries below carry
      // no payer.
      breakdown.push({
        type: 'Online Payment',
        amount: amount,
        date: payment.paidDate,
        description: `Payment via ${payment.provider || 'card'}`,
        paidByName: payment.paidByName || null,
        paidByEmail: payment.paidByEmail || null,
      });
    });

    // Add custom paid amount if exists
    if (team.customPaidAmount && team.customPaidAmount > 0) {
      breakdown.push({
        type: 'Manual Payment',
        amount: team.customPaidAmount * 100, // Convert to cents
        date: team.customPaidDate || team.paidDate || new Date(),
        description: team.paidNotes || 'Manual payment recorded by admin'
      });
    } else if (team.hasPaid && (!team.customPaidAmount || team.customPaidAmount <= 0)) {
      // Fallback for teams with hasPaid but no custom amount (shouldn't happen with validation)
      breakdown.push({
        type: 'Manual Payment',
        amount: 0,
        date: team.customPaidDate || team.paidDate || new Date(),
        description: team.paidNotes || 'Manual payment recorded by admin (amount not specified)'
      });
    }

    return breakdown;
  }

  // Resolve a division's effective capacity/waitlist config for the capacity
  // derivation. Capacity & hasWaitlist follow the inherit-when-no-own pattern
  // used by OrganizeAdmin.tsx DivisionRow: the division wins when it has its own
  // cap > 0, otherwise inherit both from the parent league (looked up in the
  // registration's contests). Mongoose defaults capacity=0 / hasWaitlist=false,
  // so a plain undefined check doesn't work — hence own>0. Returns a shape the
  // waitlist utils accept ({ _id, config }).
  const getEffectiveDivisionConfig = (division) => {
    if (!division) return null;
    const ownCap = Number(division.config?.capacity || 0);
    const divisionLeagueId = _.get(division, 'league._id') || _.get(division, 'league');
    const parentLeague = _.find(_.get(registration, 'contests', []), (c) => c._id === divisionLeagueId);
    const parentCap = Number(parentLeague?.config?.capacity || 0);
    const effectiveCapacity = ownCap > 0 ? ownCap : parentCap;
    const effectiveHasWaitlist = ownCap > 0
      ? !!division.config?.hasWaitlist
      : !!parentLeague?.config?.hasWaitlist;
    return {
      _id: division._id,
      config: {
        capacity: effectiveCapacity,
        hasWaitlist: effectiveHasWaitlist,
        promotionPaymentWindowHours: division.config?.promotionPaymentWindowHours
          ?? parentLeague?.config?.promotionPaymentWindowHours,
      },
    };
  };

  const getPaymentDate = (registrationTeam, hasTime = false) => {
    const payment = _.find(payments, { registrationTeam: registrationTeam._id, donation: false });
    if (!payment) {
      return '';
    }

    const paidDate = new Date(_.get(payment, 'paidDate'));
    const dateFormatted = hasTime ? moment(paidDate).format('MM/DD/YYYY hh:mm:ss a') : moment(paidDate).format('MM/DD/YYYY');
    return dateFormatted;
  };

  function calculateTotalPayments(registrationTeam, isRaw = false) {
    const cost = _.get(registration, 'cost');
    if (cost?.perPlayer) {
      return isRaw ? cost.amount * _.get(registrationTeam, 'players.length') : convertToUSD(cost.amount * _.get(registrationTeam, 'players.length'));
    } else {
      return isRaw ? cost?.amount : convertToUSD(cost?.amount);
    }
  };

  function calculateTotalPayments2(registrationTeam, isRaw = false, teamPlayers = []) {
    // Prefer the server-resolved cost (multi-team / early-bird discounts
    // applied). `findAllByRegistrationId` now includes `resolvedCost` per
    // team — see `calculateTeamCost` in packages/shared/utils. Fall back to
    // the legacy `amount * playerCount` for any team that predates the
    // backend rewrite or has no paymentProduct attached.
    if (typeof registrationTeam?.resolvedCost === 'number') {
      return isRaw ? registrationTeam.resolvedCost : convertToUSD(registrationTeam.resolvedCost);
    }
    const paymentProduct = _.find(paymentProducts, { _id: registrationTeam.paymentProductId });
    if (!paymentProduct) {
      return isRaw ? 0 : convertToUSD(0);
    }
    const raw = calculatePaymentDue(paymentProduct, teamPlayers.length);
    return isRaw ? raw : convertToUSD(raw);
  };

  const getPlayerAggregatedData = (registrationTeams, fields, profileFieldDefs: any[] = [], profileMaps: any = {}) => {
    const foobar = _.reduce(fields, (result, { name, fieldId, fieldType, options }, key) => {
      if (fieldType != 'select') {
        return result;
      }
      if (!result[name]) {
        result[name] = {};
      }
      _.each(options, (option) => {
        if (!result[name][option]) {
          result[name][option] = 0;
        }
      })
      _.each(registrationTeams, (team) => {
        _.each(team.players, (player) => {


          const fieldValue = _.get(player, `info.${fieldId}`);
          if (fieldValue && !result[name][fieldValue]) {
            result[name][fieldValue] = 0;
          }
          if (fieldValue) {
            result[name][fieldValue] += 1;
          }
        });
      });
      return result;
    }, {});

    _.each(profileFieldDefs, ({ name, fieldId, fieldType, options }: any) => {
      if (fieldType !== 'select') return;
      const key = `Profile: ${name}`;
      if (!foobar[key]) foobar[key] = {};
      _.each(options, (opt: string) => {
        if (!foobar[key][opt]) foobar[key][opt] = 0;
      });
      _.each(registrationTeams, (team: any) => {
        _.each(team.players, (player: any) => {
          const up = resolveUserProfile(profileMaps, player);
          const v = _.get(up, ['info', fieldId]);
          if (!v) return;
          if (!foobar[key][v]) foobar[key][v] = 0;
          foobar[key][v] += 1;
        });
      });
    });

    return foobar;
  };

  const teamMapper = (team, teamPlayers = []) => {
    const totalPayments = calculateTotalPayments2(team, true, teamPlayers);
    const paymentMade = getTotalPaymentMade(team, true);
    const paymentDate = getPaymentDate(team, true);
    const donationTotal = filterPaymentsByRegistrationId({ registrationTeamId: team._id, donation: true, raw: true });
    // Three-state payment status: teams that paid something but not everything
    // export as "Partial" (previously lumped in with "Unpaid").
    const paidAmt = Number(paymentMade);
    const dueAmt = Number(totalPayments);
    const status = paidAmt > 0 && paidAmt >= dueAmt ? 'Paid' : paidAmt > 0 ? 'Partial' : 'Unpaid';
    const adminStatus = team.status || '';
    const teamDivisionId = _.get(team, 'division._id') || _.get(team, 'requestedDivision._id');
    const teamDivision = _.find(divisions, (d) => d._id === teamDivisionId);
    const capacityState = teamDivision
      ? getCapacityState(team, getRegistrationTeamsForDivision(teamDivisionId, registrationTeams), teamDivision)
      : 'secured';
    const coaches = _.reduce(team.teamManagers, (result, manager, index) => {
      result[`coach${index + 1}FullName`] = `${_.get(manager, 'first_name')} ${_.get(manager, 'last_name')}`;
      result[`coach${index + 1}Email`] = _.get(manager, 'email');
      result[`coach${index + 1}Phone`] = _.get(manager, 'phone');
      return result;
    }, {});
    const teamInfo = _.reduce(team.info, (result, value, key) => {
      result[key] = value;
      return result;
    }, {});
    return {
      
      teamId: _.get(team, '_id'),
      teamName: getDisplayNameForRegistrationTeam(team),
      // entityLabel keeps soft-deleted divisions/contests legible in the export
      // (suffixed "(deleted)") instead of exporting an empty cell.
      requestedContest: entityLabel(_.get(team, 'requestedContest')),
      contest: entityLabel(_.get(team, 'contest')) || entityLabel(_.get(team, 'requestedContest')),
      requestedDivision: entityLabel(_.get(team, 'requestedDivision')),
      selectedDivision: entityLabel(_.get(team, 'division')) || entityLabel(_.get(team, 'requestedDivision')),
      // divisionTeam is populated by the admin fetch (?include=divisionTeam).
      seed: _.get(team, 'divisionTeam.seed', ''),

      userFullName: _.get(team, 'user.name'),
      userEmail: _.get(team, 'user.email'),
      ...coaches,
      ...teamInfo,
      // organization: _.get(team, 'organization'),
      totalPayments: Number(totalPayments/100).toFixed(2),
      paymentMade: Number(Number(paymentMade)/100).toFixed(2),
      paymentDate,
      donationTotal: Number(Number(donationTotal)/100).toFixed(2),
      status,
      adminStatus,
      capacityState,
    };
  }

  const downloadCSV = (rr) => {

      const teams = _.map(rr, (team) => {
        const teamPlayers = _.filter(playersWithInfo, (player) => {
          return helpers.getObjId(player.registrationTeam) === team._id; 
        });
        return teamMapper(team, teamPlayers);
      });

      var csvContent = Papa.unparse(teams);

      const encodedUri = encodeURI(csvContent);
      console.log('csv: ', csvContent);

      var download = function(content, fileName, mimeType) {
        var a = document.createElement('a');
        mimeType = mimeType || 'application/octet-stream';

        if (URL && 'download' in a) { //html5 A[download]
          a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType
          }));
          a.setAttribute('download', fileName);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          window.location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
        }

      }

      const downloadFileName = `teams-${selectedContest}-${_.join(selectedDivisions, ',')}-${moment().format('MM-DD-YYYY')}.csv`
      download(csvContent, downloadFileName, 'text/csv;encoding:utf-8');
  }

  const playerMapper = (player, fields, team = {}) => {
    const info = player.info || {};

    // Friendly label per registration field; e.g. first_name -> "First Name".
    const labelById = _.reduce(fields, (acc: any, { name, fieldId }: any) => {
      if (fieldId) acc[fieldId] = name || _.startCase(fieldId);
      return acc;
    }, {});

    // `registration.fields` only lists a subset (e.g. First/Last Name), but
    // `player.info` is free-form and carries everything the player entered
    // (dupr, email, birth_date, …). Export ALL info keys: registration-field
    // ids first (stable order), then any remaining keys, labeled via the
    // registration field name or a start-cased fallback.
    const orderedKeys = _.uniq([
      ..._.map(fields, 'fieldId').filter(Boolean),
      ...Object.keys(info),
    ]);
    const playerInfoColumns = _.reduce(orderedKeys, (acc: any, key: string) => {
      const label = labelById[key] || _.startCase(key);
      const v = info[key];
      acc[label] = (v && typeof v === 'object') ? (v.value ?? JSON.stringify(v)) : v;
      return acc;
    }, {});

    const userProfile = resolveUserProfile(profileMaps, player);
    const profileColumns = _.reduce(profileFields, (acc: any, { name, fieldId }: any) => {
      acc[`Profile: ${name}`] = _.get(userProfile, ['info', fieldId]);
      return acc;
    }, {});

    let teamInfo = _.omit(team , ['paymentDate', 'paymentMade', 'donationTotal', 'status', 'totalPayments']);

    // Waiver Status per player — same derivation as the on-screen chip
    // (getPlayerWaiverStatus). When the registration requires no player waivers,
    // emit "Not Required" rather than a misleading "Pending".
    const waiverRequired = _.get(registration, 'playerWaivers', []).length > 0;
    const waiverStatus = waiverRequired
      ? (getPlayerWaiverStatus(player) === 'signed' ? 'Signed' : 'Pending')
      : 'Not Required';

    // Surface the team's paid amount (same value/format as the on-screen
    // "Payment Made" cell and the teams export). `_.omit` above strips the raw
    // `paymentMade` key, so add one clean, clearly-labeled column instead.
    return { playerId: player._id, ...teamInfo, 'Payment Made': team.paymentMade, 'Waiver Status': waiverStatus, ...playerInfoColumns, ...profileColumns };
  }

  const downloadPlayerCSV = (rr) => {

    // if (this.props.teamRegistrations.length) {
      
      const players = _.map(rr, (team) => {
        const teamPlayers = _.filter(playersWithInfo, (player) => {
          return helpers.getObjId(player.registrationTeam) === team._id; 
        });
        const list = _.map(teamPlayers, (player) => {
          return playerMapper(player, _.get(registration, 'fields', []), teamMapper(team, teamPlayers));
        });

        return list;
      });
      const flattened = _.flatten(players);

      // Players have differing `info` keys (e.g. only some entered dupr /
      // birth_date), so let columns be the union of every row's keys —
      // otherwise PapaParse derives the header from the first row alone and
      // drops fields the first player happened to lack.
      const columns = _.uniq(_.flatMap(flattened, Object.keys));
      var csvContent = Papa.unparse({
        fields: columns,
        data: _.map(flattened, (r) => _.map(columns, (c) => r[c] ?? '')),
      });

      var download = function(content, fileName, mimeType) {
        var a = document.createElement('a');
        mimeType = mimeType || 'application/octet-stream';

        if (URL && 'download' in a) { //html5 A[download]
          a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType
          }));
          a.setAttribute('download', fileName);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          window.location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
        }

      }

      const downloadFileName = `players-${selectedContest}-${_.join(selectedDivisions,',')}-${moment().format('MM-DD-YYYY')}.csv`
      download(csvContent, downloadFileName, 'text/csv;encoding:utf-8');
    // }
  }


  const chosenContest = selectedContest === 'All' ? { name: 'All Format' } : _.find(_.get(registration, 'contests', []), { _id: selectedContest });

  const playerAggregatedData = getPlayerAggregatedData(registered, _.get(registration, 'fields', []), profileFields, profileMaps);

  // const rowsPerPage = 20;
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // Check if any filters are active
  const hasActiveFilters = selectedContest !== 'All' || 
    selectedDivisions.length > 0 || 
    searchTerm !== '' || 
    paymentFilter !== 'all' || 
    acceptanceFilter !== 'all';

  // Clear all filters
  const clearAllFilters = useCallback(() => {
    setSelectedContest('All');
    setSelectedDivisions([]);
    setSearchTerm('');
    setPaymentFilter('all');
    setAcceptanceFilter('all');
    setCurrentPage(1);
  }, []);

  let startPageRange = rowsPerPage * (currentPage - 1) + 1;
  let endPageRange = rowsPerPage * currentPage;

  const updateDivision = async (divisionId, team) => {
    console.log('updateDivision::divisionId::', divisionId, team);
    const token = await getToken();
    // team.division = divisionId;
    const updated = {
      ...team,
      division: divisionId,
    }
    console.log('updateDivision::team::', team);
    await updateTeamRegistration(updated, token, (res) => {
      console.log('updateTeamRegistration::updated::', res);
      toast({
        description: `${getDisplayNameForRegistrationTeam(res)} updated successfully`,
      });

    });
  }

  // Division dropdown → check the target division's eligibility first. If the
  // roster passes, move immediately (no prompt). If not, open the override
  // dialog listing which players break which rules; the admin can Override & Move.
  const handleDivisionSelect = async (divisionId, team) => {
    const newDivisionObj = _.find(divisions, { _id: divisionId }) || {};
    const token = await getToken();
    const { ok, reasons, isFull } = await checkDivisionEligibility(team._id, divisionId, token);
    // Full target division → hard block, move is voided (no override).
    if (isFull) {
      toast({
        variant: 'destructive',
        description: `${newDivisionObj.name || 'That division'} is full. Team not moved.`,
      });
      return;
    }
    if (ok) {
      updateDivision(divisionId, team);
      return;
    }
    setPendingDivisionMove({ team, divisionId, toDivisionName: newDivisionObj.name, reasons });
  };

  // ── Free-agent pool (ADR 0054) ────────────────────────────────────────────
  const toggleFreeAgentSelected = (id: string) => setSelectedFreeAgents((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);

  // A placed pool entry points at its DivisionTeam via assignedDivisionTeam
  // (bare id — not populated by findAllByRegistrationId); resolve the name
  // from the teamDivisions store, refetched after every assignment.
  const placedTeamLabel = (rt) => {
    const dtId = helpers.getObjId(_.get(rt, 'assignedDivisionTeam'));
    const dt = _.find(teamDivisions, (t) => String(t._id) === String(dtId));
    return dt ? getTeamDisplayName(dt) : 'assigned';
  };

  const handleAssignFreeAgents = async () => {
    const target = assignMode === 'existing'
      ? { divisionTeamId: assignDivisionTeamId }
      : { newTeam: { name: assignNewTeamName.trim(), divisionId: assignDivisionId } };
    const destinationName = assignMode === 'existing'
      ? getTeamDisplayName(_.find(teamDivisions, (dt) => String(dt._id) === String(assignDivisionTeamId)))
      : assignNewTeamName.trim();
    const count = selectedFreeAgents.length;
    setAssigning(true);
    try {
      await assignFreeAgents({
        organization: helpers.getObjId(_.get(registration, 'organization')),
        freeAgentIds: selectedFreeAgents,
        target,
      });
      toast({ description: `${count} player${count === 1 ? '' : 's'} assigned to ${destinationName}` });
      setAssignDialogOpen(false);
      setSelectedFreeAgents([]);
      setAssignDivisionTeamId('');
      setAssignNewTeamName('');
      // Refresh the pool + grid (statuses / assignedDivisionTeam changed) and
      // the divisionTeams list (a new team may have been created).
      await async_getRegistrationTeamsByRegistrationId(registrationId);
      await async_getTeamDivisionsByRegistrationId(registrationId);
    } catch (e) {
      // The store thunk already surfaced the backend reason via showError.
      console.error('assignFreeAgents failed:', e);
    } finally {
      setAssigning(false);
    }
  };

  const updateContest = async (contestId, team) => {
    console.log('updateContest::contestId::', contestId, team);
    const token = await getToken();
    // team.contest = contestId;
    const updated = {
      ...team,
      contest: contestId,
    }
    console.log('updateContest::team::', team);
    await updateTeamRegistration(updated, token, (res) => {
      console.log('updateTeamRegistration::updated::', res);
      toast({
        description: `${getDisplayNameForRegistrationTeam(res)} updated successfully`,
      });
    
    });
  }

  const getCanPreviousPage = () => {
    return currentPage > 1;
  }
  const getCanNextPage = () => {
    return registered.length > endPageRange;
  }

  const hasAcceptedTeams = _.filter(registered, { status: 'accepted' }).length;

  // Where "Setup Game Schedule(s)" goes: tournament registrations (including
  // registrations on a tournament CONTEST — its league carries .tournament)
  // open the tournament's Day2 calendar; standalone-season registrations open
  // the season scheduler. `registration.tournament` is a bare id; `contests`
  // is the populated League array the show endpoint attaches.
  const scheduleHref = (() => {
    const tournamentId = helpers.getObjId(_.get(registration, 'tournament'));
    if (tournamentId) return `/admin/scheduler-day2/tournament/${tournamentId}`;
    const contest = _.get(registration, 'contests[0]');
    const parentTournamentId = helpers.getObjId(_.get(contest, 'tournament'));
    if (parentTournamentId) return `/admin/scheduler-day2/tournament/${parentTournamentId}`;
    const leagueId = helpers.getObjId(_.get(registration, 'contest')) || helpers.getObjId(contest);
    return leagueId ? `/admin/organization/scheduler/${leagueId}` : null;
  })();

  const findTeam = (event) => {
    const value = event.target.value;
    console.log('findTeam::value::', value);
    const found = _.filter(registered, (team) => {
      return _.get(team, 'teamName', '').toLowerCase().includes(value.toLowerCase());
    });
    console.log('findTeam::found::', found);
  }

  const getHighlightedText = (text = '', highlight) => {
    // Split text on highlight term, include term itself into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return <span>{parts.map(part => part.toLowerCase() === highlight.toLowerCase() ? <b>{part}</b> : part)}</span>;
  }


  const registeredFilter = _.chain(registered)
  .filter(matchesDivisionFilter)
  .filter(matchesTeamSearch).value();

  // Registrations/Players are a record of registrations RECEIVED, so withdrawn
  // teams ARE counted — they registered, and their payments are already in the
  // money totals below. (Capacity is a different question with a different
  // answer: a withdrawn team holds no seat. That lives in `deriveCapacityStates`
  // and is untouched by this. See registrationCounts.ts + ADR 0031.)
  const { registrations: registeredCount, matchedPlayers: playerFilter } =
    deriveRegistrationCounts({ teams: registeredFilter, players: playersWithInfo });

  const filteredPayments = _.filter(payments, (payment) => {
    return _.find(registeredFilter, { _id: payment.registrationTeam });
  });
  const paymentTotal = _.chain(filteredPayments).filter({ donation: false }).sumBy('amount').value();
  const donationTotal = _.chain(filteredPayments).filter({ donation: true }).sumBy('amount').value();
  // const playerTotal = _.chain(registeredFilter).map('players').flatten().value().length;


  const registeredRange = _.chain(registeredFilter)
  .filter(matchesDivisionFilter)
  .filter(matchesTeamSearch)
  .orderBy(['teamName'], [teamNameSort || 'asc'])
  .orderBy(['created'], [createdSort || 'asc'])
  // Dominant sort (lodash's last orderBy wins): player-name-only matches (rank 1)
  // sink below team-name/email matches (rank 0). No-op when not searching.
  .orderBy([(team) => teamSearchRank(team)], ['asc'])
  .filter((team, index) => {
    return index >= startPageRange - 1 && index < endPageRange;
  })
  .value();

  // const registeredRange = _.filter(registered, (team, index) => {
  //   return index >= startPageRange - 1 && index < endPageRange;
  // });

  
  
  const getAllInfoFields = () => {
    const allFields = new Set();
    _.each(registered, (team) => {
      _.each(_.keys(team.info || {}), (key) => {
        allFields.add(key);
      });
    });
    return Array.from(allFields);
  };

  const getPaymentFilterLabel = () => {
    switch (paymentFilter) {
      case "paid":
        return "Partial Paid"
      case "fully_paid":
        return "Fully Paid"
      case "unpaid":
        return "Unpaid"
      default:
        return "All"
    }
  }

  const getAcceptanceFilterLabel = () => {
    switch (acceptanceFilter) {
      case "accepted":
        return "Accepted"
      case "not-accepted":
        return "Not Accepted"
      default:
        return "All"
    }
  }

  const handleTeamNameSort = () => {
    if (teamNameSort === null || teamNameSort === 'asc') {
      setTeamNameSort('desc');
    } else {
      setTeamNameSort('asc');
    }
  };

  const handleCreatedSort = () => {
    if (createdSort === null || createdSort === 'asc') {
      setCreatedSort('desc');
    } else {
      setCreatedSort('asc');
    }
  };

  const updateRegistrationSettingsFunction = async () => {
    try {
      console.log('updateRegistrationSettings::registrationSettings::', registrationSettings, registration);
      const updated = {
        ...registration,
        settings: {
          numDaysToRemindTeam: registrationSettings.numDaysToRemindTeam,
          emailReminderTeam: registrationSettings.emailReminderTeam,
          rosterLock: registrationSettings.rosterLock,
          rosterLockDate: registrationSettings.rosterLockDate,
        }
      };
      console.log('updateRegistrationSettings::updated::', updated);
      debugger;
      await updateRegistrationSettings(updated, (updatedRegistration) => {
        // setRegistration(updatedRegistration);
        setShowSettings(false);
      });
    } catch (error) {
      console.error('Failed to update settings:', error);
    }
  };

  const getPaymentStatus = (team, teamPlayers) => {
    const paymentDueRaw = Number(calculateTotalPayments2(team, true, teamPlayers));
    const paymentMadeRaw = Number(getTotalPaymentMade(team, true));
    const status = getPaymentStatusShared(paymentDueRaw, paymentMadeRaw, team.hasPaid);

    if (status === 'partial') {
      return (
        <>
          <Clock className="h-4 w-4 text-warning" />
          <Badge
            variant="outline"
            className="bg-warning/10 text-warning border-warning/30"
          >
            Partial
          </Badge>
        </>
      );
    } else if (status === 'overpaid') {
      return (
        <>
          <CheckCircle2 className="w-4 h-4 text-info" />
          <Badge
            variant="outline"
            className="bg-info/10 text-info border-info/30"
          >
            Overpaid
          </Badge>
        </>
      );
    } else if (status === 'paid') {
      return (
        <>
          <CheckCircle2 className="w-4 h-4 text-success" />
          <Badge
            variant="outline"
            className="bg-success/10 text-success border-success/30"
          >
            Paid
          </Badge>
        </> 
      );
    } else if (status === 'unpaid') {
      return (
        <>
          <AlertCircle className="h-4 w-4 text-destructive" />
          <Badge
            variant="outline"
            className="bg-destructive/10 text-destructive border-destructive/30"
          >
            Unpaid
          </Badge>
        </>
      );
    } else if (status === 'paid_manually') {
      const stripePaymentsRaw = filterPaymentsByRegistrationId({ registrationTeamId: team._id, donation: false, raw: true });
      const hasStripePayments = Number(stripePaymentsRaw) > 0;
      const hasCustomAmount = team.customPaidAmount && team.customPaidAmount > 0;
      
      let badgeText = 'Paid Manually';
      let description = 'The "hasPaid" field has been manually selected for this team';
      
      if (hasStripePayments && hasCustomAmount) {
        badgeText = 'Paid (Mixed)';
        description = 'Team has both manual and online payments recorded';
      } else if (hasStripePayments) {
        badgeText = 'Paid (Online)';
        description = 'Team has online payments recorded and manual payment status';
      } else if (hasCustomAmount) {
        badgeText = 'Paid (Manual)';
        description = 'Team has manual payment amount recorded';
      }
      
      return (
        <>
          <CheckCircle2 className="w-4 h-4 text-success" />
          <HoverCard>
            <HoverCardTrigger>
              <Badge
                variant="outline"
                className="bg-success/10 text-success border-success/30 cursor-help"
              >
                {badgeText}
              </Badge>
            </HoverCardTrigger>
            <HoverCardContent>
              <div className="text-sm">
                {description}
              </div>
            </HoverCardContent>
          </HoverCard>
        </>
      )
    }

    return <></>;
  }

  return (
    <PageContainer key={'RegistrationAdmin'}>
      <section className="w-full py-0 md:py-0 lg:py-0">
      <div className="px-2 md:px-2">
        {/* grid-cols-[minmax(0,1fr)]: a default `auto` grid track sizes to its
            widest item, and grid items default to `min-width: auto` — so the wide
            teams table below stretched this whole column past the viewport, taking
            the header's action buttons out of reach with it. Pinning the track to
            minmax(0,1fr) lets every child shrink to the column and handle its own
            overflow. */}
        <div className="grid grid-cols-[minmax(0,1fr)] gap-6">
          {/* flex-wrap lets the action buttons drop to their own line on a narrow
              viewport instead of being clipped. */}
          <div className="grid gap-4 min-w-0">
            <PageHeader
              title="Tournament Registration"
              actions={(
                <>
                <Button variant="outline" size="default" onClick={() => navigate(`/admin/registration/${registrationId}/edit`)}>
                  <Pencil className="mr-1 h-4 w-4" /> Edit Registration
                </Button>
                <Button variant="outline" size="default" onClick={() => setShowEmbedModal(true)}>
                  <Code2 className="mr-1 h-4 w-4" /> Embed
                </Button>
                <HoverCard>
                  <HoverCardTrigger>
                  <Button
                    size="default"
                    disabled={!hasAcceptedTeams || !scheduleHref}
                    onClick={() => scheduleHref && navigate(scheduleHref)}
                  >
                    Setup Game Schedule(s)
                  </Button>
                  </HoverCardTrigger>
                  <HoverCardContent>
                    <div className="p-4">
                      <div className="text-sm font-medium">
                        {!hasAcceptedTeams
                          ? 'Accept teams to start scheduling games'
                          : !scheduleHref
                            ? "This registration isn't linked to a tournament or season yet."
                            : 'Open the scheduler to create and arrange games'}
                      </div>
                    </div>
                  </HoverCardContent>
                </HoverCard>
                <DropdownMenu>
                  <DropdownMenuTrigger
                    className="rounded p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    aria-label="More registration actions"
                  >
                    <Ellipsis className="h-4 w-4" />
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => setShowCloneRegistration(true)}>
                      <Copy className="mr-2 h-4 w-4" /> Clone Registration
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      className="text-destructive focus:text-destructive"
                      onClick={() => setShowDeleteRegistration(true)}
                    >
                      <Trash2 className="mr-2 h-4 w-4" /> Delete Registration
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
                </>
              )}
            />
            <ConfirmDeleteDialog
              open={showDeleteRegistration}
              onOpenChange={(o) => { if (!o) setShowDeleteRegistration(false); }}
              title="Delete Registration"
              description={(
                <span>
                  This permanently removes this registration from your admin. Its public sign-up page
                  stops working. Teams that already registered are not deleted, but they will no longer
                  be reachable from a registration dashboard.
                </span>
              )}
              loading={deletingRegistration}
              onConfirm={async () => {
                setDeletingRegistration(true);
                try {
                  await deleteRegistration(registrationId);
                  navigate('/admin/registration');
                } finally {
                  setDeletingRegistration(false);
                }
              }}
            />
            <CloneRegistrationModal
              isOpen={showCloneRegistration}
              onClose={() => setShowCloneRegistration(false)}
              registrationToClone={showCloneRegistration ? registration : null}
            />
            <EmbedCodeModal
              open={showEmbedModal}
              onOpenChange={setShowEmbedModal}
              registrationId={registrationId}
              orgSlug={leagueName}
            />
            {/* <h1 className="text-3xl font-bold tracking-tight">Tournament Registrations</h1> */}

            {/* Discount codes (ADR 0026) — collapsed by default, lazy-loads. */}
            <DiscountCodesCard registrationId={registrationId} />

            <div className="grid gap-4 grid-cols-3">
              <div className="rounded-lg bg-muted p-4 grid-cols-2 grid gap-2">
                <div>
                  <div className="text-sm font-medium">Registrations</div>
                  <div className="text-3xl font-bold">{registeredCount}</div>
                </div>
                <div>
                  <div className="text-sm font-medium">Total Payments</div>
                  <div className="text-3xl font-bold">{convertToUSD(paymentTotal)}</div>
                </div>
                <div>
                  <div className="text-sm font-medium">Players</div>
                  <div className="text-3xl font-bold">{playerFilter.length}</div>
                </div>
                <div>
                  <div className="text-sm font-medium">Total Donations</div>
                  <div className="text-3xl font-bold">{convertToUSD(donationTotal)}</div>
                </div>
              </div>
              <div className="rounded-lg bg-muted p-4">
                <div className="text-sm font-medium">{chosenContest?.name} Divisions ({divisions && divisions.length ? divisions.length: 0})</div>
                <div
                  className="mt-3 grid items-start justify-items-center gap-2.5"
                  style={{
                    maxHeight: '260px',
                    overflowY: 'auto',
                    // Columns follow the division count (max 3): 3+ divisions form the
                    // same 3-col grid as individual sports; a single/few divisions
                    // render compact (cards cap at max-w-[11rem]) and centered so a
                    // lone division isn't stranded left. items-start keeps cards from
                    // stretching into a tall empty box.
                    gridTemplateColumns: `repeat(${Math.min(divisions?.length || 1, 3)}, minmax(0, 1fr))`,
                  }}
                >
                  {_.map(divisions, (division) => {
                    // Withdrawn teams are excluded HERE but NOT from the headline
                    // cards above: this chip answers "how full is this division",
                    // and the capacity bar right below it drops withdrawn teams
                    // too, so counting them here would make the chip disagree with
                    // its own bar. Filtered at this level rather than upstream
                    // because `registeredFiltered` also feeds the table below,
                    // where withdrawn teams must stay visible.
                    const filteredByDivision = teamsOccupyingDivision(registeredFiltered, division._id);
                    const isSelected = selectedDivisions.includes(division._id);

                    // Resolve capacity/waitlist via the shared helper (handles the
                    // division-default-0 shadowing by inheriting from the parent
                    // league found in registration.contests).
                    const effCfg = getEffectiveDivisionConfig(division);
                    const effectiveCapacity = Number(effCfg?.config?.capacity || 0);
                    let capacity: { total: number; pct: number; isFull: boolean } | null = null;
                    if (effectiveCapacity > 0) {
                      const teamsInDivision = getRegistrationTeamsForDivision(division._id, filteredRegisteredBySeason);
                      const counts = getDivisionCapacityCounts(teamsInDivision, effCfg);
                      const total = counts.secured + counts.waitlisted;
                      capacity = {
                        total,
                        pct: Math.min(100, Math.round((total / effectiveCapacity) * 100)),
                        isFull: total >= effectiveCapacity,
                      };
                    }

                    return (
                      <div
                        key={division._id}
                        role="button"
                        tabIndex={0}
                        aria-pressed={isSelected}
                        title={division.name}
                        onClick={() => onToggleDivision(division._id)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onToggleDivision(division._id);
                          }
                        }}
                        className={cn(
                          'group flex w-full max-w-[11rem] cursor-pointer select-none flex-col items-center rounded-xl border p-3 text-center transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                          isSelected
                            // Selected = solid primary card with inverted text so it
                            // clearly stands out from the gray section (bg-primary/10
                            // was ~the same gray and blended in). Inverts correctly in
                            // dark mode (primary flips to near-white).
                            ? 'border-primary bg-primary text-primary-foreground shadow-md'
                            : 'border-border bg-card hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md',
                        )}
                      >
                        <div
                          className={cn(
                            'line-clamp-2 min-h-[2rem] text-xs font-semibold leading-tight',
                            isSelected ? 'text-primary-foreground' : 'text-foreground/80',
                          )}
                        >
                          {division.name}
                        </div>
                        <div
                          className={cn(
                            'mt-1 text-2xl font-bold leading-none tabular-nums',
                            isSelected ? 'text-primary-foreground' : 'text-foreground',
                          )}
                        >
                          {filteredByDivision.length}
                        </div>
                        {capacity && (
                          <div className="mt-2 w-full">
                            <div
                              className={cn(
                                'text-[11px] font-medium tabular-nums',
                                isSelected ? 'text-primary-foreground/70' : 'text-muted-foreground',
                              )}
                            >
                              {capacity.total} / {effectiveCapacity}
                            </div>
                            <div
                              className={cn(
                                'mt-1 h-1.5 w-full overflow-hidden rounded-full',
                                isSelected ? 'bg-primary-foreground/25' : 'bg-muted',
                              )}
                            >
                              <div
                                className={cn(
                                  'h-full rounded-full transition-all duration-300',
                                  capacity.isFull ? 'bg-warning' : 'bg-success',
                                )}
                                style={{ width: `${capacity.pct}%` }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="rounded-lg bg-muted p-4">
                <div className="mb-3 flex items-center justify-between">
                  <h3 className="text-sm font-semibold text-foreground">Filters</h3>
                  <Popover>
                    <PopoverTrigger asChild>
                      <Ellipsis className="w-5 h-5 text-muted-foreground cursor-pointer" />
                    </PopoverTrigger>
                    <PopoverContent className="w-80">
                      <div className="grid gap-4">
                        <div className="space-y-2">
                          <h4 className="font-medium leading-none">Exports</h4>
                          <p className="text-sm text-muted-foreground">
                            Set the dimensions for the layer.
                          </p>
                        </div>
                        <div className="gap-2 cursor-pointer flex items-center justify-start" onClick={() => downloadCSV(registeredFilter)}>
                          <div>Teams</div>
                          <DownloadCloudIcon className="w-4 h-4 text-muted-foreground " />
                        </div>
                        <div className="gap-2 cursor-pointer flex items-center justify-start" onClick={() => downloadPlayerCSV(registeredFilter)}>
                          <div>Players</div>
                          <DownloadCloudIcon className="w-4 h-4 text-muted-foreground " />
                        </div>
                        <div className="gap-2 cursor-pointer flex items-center justify-start" onClick={() => downloadReleaseStatement(registration)}>
                          <div>Release Statement</div>
                          <DownloadCloudIcon className="w-4 h-4 text-muted-foreground" />
                        </div>
                        <div className="gap-2 cursor-pointer flex items-center justify-start" onClick={() => {
                          setRegistrationSettings(registration?.settings || {});
                          setShowSettings(true);
                        }}>
                          <div>Registration Settings</div>
                          <Settings className="w-4 h-4 text-muted-foreground" />
                        </div>
                      </div>
                    </PopoverContent>
                  </Popover>
                </div>

                {/* All four team filters share one uniform 2-column grid: same
                    label style, control width, and spacing. */}
                <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                  {/* Format (full width) */}
                  <div className="col-span-2">
                    <div className="mb-1 text-sm font-medium">Format</div>
                    <Select
                      value={selectedContest}
                      onValueChange={onContestChange}
                    >
                      <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select format" />
                      </SelectTrigger>
                      <SelectContent>
                        {_.get(registration, 'contestType') !== 'season' && (
                          <SelectItem value="All">All Formats</SelectItem>
                        )}
                        {_.map(_.get(registration, 'contests', []), (contest) => (
                          <SelectItem key={contest._id} value={contest._id}>
                            {contest.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  {/* Division (full width) */}
                  <div className="col-span-2">
                    <div className="mb-1 text-sm font-medium">Division</div>
                    {/* DropdownMenu + CheckboxItem (not a single-select Select) so
                        clicking a checked division toggles it OFF — Radix Select's
                        onValueChange only fires on a value CHANGE, so re-clicking the
                        selected item never fired and divisions couldn't be unselected. */}
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="outline" className="justify-between min-w-full font-normal">
                          <span className="truncate">
                            {selectedDivisions.length === 0
                              ? 'All Divisions'
                              : _.map(_.filter(divisions, d => selectedDivisions.includes(d._id)), 'name').join(', ')}
                          </span>
                          <ChevronDown className="ml-2 h-4 w-4 shrink-0" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="start" className="max-h-72 w-full overflow-y-auto">
                        {_.map(divisions, (division) => (
                          <DropdownMenuCheckboxItem
                            key={division._id}
                            checked={selectedDivisions.includes(division._id)}
                            onCheckedChange={() => onToggleDivision(division._id)}
                            onSelect={(e) => e.preventDefault()}
                          >
                            {division.name}
                          </DropdownMenuCheckboxItem>
                        ))}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>

                  {/* Payment Status */}
                  <div>
                    <div className="mb-1 text-sm font-medium">Payment Status</div>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="outline" className="justify-between min-w-full font-normal">
                          {getPaymentFilterLabel()}
                          <ChevronDown className="ml-2 h-4 w-4 shrink-0" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="start" className="w-full">
                        <DropdownMenuRadioGroup value={paymentFilter} onValueChange={(v) => { setCurrentPage(1); setPaymentFilter(v); }}>
                          <DropdownMenuRadioItem value="all">All</DropdownMenuRadioItem>
                          <DropdownMenuRadioItem value="paid">Partial Paid</DropdownMenuRadioItem>
                          <DropdownMenuRadioItem value="fully_paid">Fully Paid</DropdownMenuRadioItem>
                          <DropdownMenuRadioItem value="unpaid">Unpaid</DropdownMenuRadioItem>
                        </DropdownMenuRadioGroup>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>

                  {/* Acceptance Status */}
                  <div>
                    <div className="mb-1 text-sm font-medium">Acceptance Status</div>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="outline" className="justify-between min-w-full font-normal">
                          {getAcceptanceFilterLabel()}
                          <ChevronDown className="ml-2 h-4 w-4 shrink-0" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="start" className="w-full">
                        <DropdownMenuRadioGroup value={acceptanceFilter} onValueChange={(v) => { setCurrentPage(1); setAcceptanceFilter(v); }}>
                          <DropdownMenuRadioItem value="all">All</DropdownMenuRadioItem>
                          <DropdownMenuRadioItem value="accepted">Accepted</DropdownMenuRadioItem>
                          <DropdownMenuRadioItem value="not-accepted">Not Accepted</DropdownMenuRadioItem>
                        </DropdownMenuRadioGroup>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              <div className="rounded-lg bg-muted px-4">
              <Accordion type="single" collapsible>
                <AccordionItem value="item-1">
                  <AccordionTrigger>Player Details</AccordionTrigger>
                  <AccordionContent>
                    {_.map(playerAggregatedData, (data, key) => (
                      <div key={key}>
                        <div className="text-sm">{key}</div>
                        <div className="grid grid-cols-3 gap-2">
                          {_.map(data, (value: string, key) => (
                            <div key={key}>
                              <div className="text-sm">{key}</div>
                              <div className="text-lg font-bold">{value}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
              </div>
              <div className="flex items-center gap-2">
                <input 
                  value={searchTerm}
                  onChange={(e) => { setCurrentPage(1); setSearchTerm(e.target.value); }} 
                  className="flex h-9 w-80 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 pl-8" 
                  placeholder="Search Team, Emails" 
                />
                {hasActiveFilters && (
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={clearAllFilters}
                    className="flex items-center gap-1 text-destructive border-destructive/30 hover:bg-destructive/10 hover:text-destructive"
                  >
                    <FilterX className="h-4 w-4" />
                    Clear Filters
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div className="border rounded-lg w-full">
            <div className="relative w-full overflow-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center gap-2">
                        Team Name
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={handleTeamNameSort}
                          className="h-6 w-6 p-0"
                        >
                          {teamNameSort === 'desc' ? (
                            <ChevronDown className="h-4 w-4" />
                          ) : teamNameSort === 'asc' ? (
                            <ChevronUp className="h-4 w-4" />
                          ) : (
                            <ChevronDown className="h-4 w-4 text-muted-foreground/60" />
                          )}
                        </Button>
                      </div>
                    </TableHead>
                    {/* <TableHead>Requested Division</TableHead> */}
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center">Division</div>
                    </TableHead>
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center">Format</div>
                    </TableHead>
                    {/* <TableHead className="p-1">
                      <div className="flex justify-center items-center">Organization</div>
                    </TableHead> */}
                    {getAllInfoFields().map((fieldName: string) => (
                      <TableHead key={fieldName} className="p-1">
                        <div className="flex justify-center items-center">{_.startCase(fieldName)}</div>
                      </TableHead>
                    ))}
                    <TableHead className="flex items-center justify-center p-1">
                      <div className="flex justify-center items-center">User</div>
                    </TableHead>
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center gap-2">
                        Created
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={handleCreatedSort}
                          className="h-6 w-6 p-0"
                        >
                          {createdSort === 'desc' ? (
                            <ChevronDown className="h-4 w-4" />
                          ) : createdSort === 'asc' ? (
                            <ChevronUp className="h-4 w-4" />
                          ) : (
                            <ChevronDown className="h-4 w-4 text-muted-foreground/60" />
                          )}
                        </Button>
                      </div>
                    </TableHead>
                    {/* <TableHead>Signed</TableHead> */}
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center">{showCoaches ? 'Players / Coaches' : 'Players'}</div>
                    </TableHead>
                    {/* <TableHead className="flex items-center justify-center p-1">
                      <div className="flex justify-center items-center">Coach</div>
                    </TableHead> */}
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center">Payment</div>
                    </TableHead>
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center">Donation(s)</div>
                    </TableHead>
                    <TableHead className="p-1">
                      <div className="flex justify-center items-center">Status</div>
                    </TableHead>
                    <TableHead />
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {_.map(registeredRange, (team) => {

                    const teamPlayers = _.filter(playersWithInfo, (player) => {
                      return _.get(player, 'registrationTeam') === team._id;
                    });

                    // Players-pay-individually teams get a per-player "Amount Paid" column.
                    const teamPaymentProduct = _.find(paymentProducts, { _id: team.paymentProductId });
                    const teamIsPlayerPay = !!(teamPaymentProduct?.playerPaySeparately && teamPaymentProduct?.perPlayer);

                    const currentContest = _.get(team, 'contest._id') || _.get(team, 'requestedContest._id');
                    const currentDivision = _.get(team, 'division._id') || _.get(team, 'requestedDivision._id');

                    // Always include the team's OWN contest/division so the
                    // Format/Division value matches an option (and auto-selects)
                    // even if registration.contests / divisions hasn't loaded or
                    // is stale. dedupe by _id keeps the full movable list intact.
                    const selectableContests = _.uniqBy(
                      [
                        ..._.get(registration, 'contests', []),
                        _.get(team, 'requestedContest'),
                        _.get(team, 'contest'),
                      ].filter((c) => c && c._id),
                      (c) => String(c._id),
                    );
                    const selectableDivisions = _.uniqBy(
                      [
                        ..._.filter(divisions, (division) => {
                          const leagueId = _.get(division, 'league._id') || _.get(division, 'league');
                          return String(leagueId) === String(currentContest);
                        }),
                        _.get(team, 'requestedDivision'),
                        _.get(team, 'division'),
                      ].filter((d) => d && d._id),
                      (d) => String(d._id),
                    );

                    const currentTeamDivision = _.find(teamDivisions, (dt) => {
                      return helpers.getObjId(_.get(dt, 'registrationTeam')) === team._id;
                    });

                    return (
                      <Collapsible key={team._id} asChild>
                        <>
                          <TableRow key={team._id}>
                            <TableCell className="min-w-32 p-1">
                              <div className="flex items-center justify-between gap-2">
                                <div className="flex items-center gap-2">
                                  {/* {helpers.isRegistrationTeamUpdated(team, currentTeamDivision, teamPlayers) && (
                                    <HoverCard>
                                      <HoverCardTrigger>
                                        <AlertCircleIcon className="h-4 w-4 text-warning" />
                                      </HoverCardTrigger>
                                      <HoverCardContent>
                                        <div className="text-sm">
                                          Team information has been updated since registration
                                        </div>
                                      </HoverCardContent>
                                    </HoverCard>
                                  )} */}
                                  <div className="flex items-center gap-1">
                                    <span>
                                      {getHighlightedText(getTeamDisplayName(currentTeamDivision), searchTerm)}
                                    </span>
                                    {_.get(currentTeamDivision, 'seed') && (
                                      <HoverCard>
                                        <HoverCardTrigger>
                                          <span className="text-muted-foreground">
                                            ({currentTeamDivision.seed})
                                          </span>
                                        </HoverCardTrigger>
                                        <HoverCardContent>
                                          <div className="text-sm">
                                            Tournament seed number. Lower numbers = higher seeds.
                                          </div>
                                        </HoverCardContent>
                                      </HoverCard>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className="min-w-24 p-1 flex flex-col">
                              {/* Division */}
                              <p className='text-xs'>Requested: {entityLabel(_.get(team, 'requestedDivision'))}</p>
                              <div className="w-[200px]">
                                <Select
                                  value={currentDivision}
                                  onValueChange={(value) => {
                                    if (value === currentDivision) return;
                                    handleDivisionSelect(value, team);
                                  }}
                                >
                                  <SelectTrigger className="h-8 text-sm">
                                    <SelectValue placeholder="Select division" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {_.map(selectableDivisions, (division) => (
                                      <SelectItem
                                        key={division._id}
                                        value={division._id}
                                        // A deleted division shows as the current value so the row
                                        // stays readable, but can't be chosen as a move target.
                                        disabled={isDeletedEntity(division)}
                                      >
                                        {entityLabel(division)}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              </div>
                            </TableCell>
                            <TableCell className="min-w-24 p-1">
                              {/* Format */}
                              <p className='text-xs'>Requested: {entityLabel(_.get(team, 'requestedContest'))}</p>
                              <div className="w-[200px]">
                                <Select
                                  value={currentContest}
                                  onValueChange={(value) => {
                                    const currentContestObj = _.find(selectableContests, { _id: currentContest }) || {};
                                    const newContestObj = _.find(selectableContests, { _id: value }) || {};
                                    const hasConfirmed = window.confirm(`Are you sure you want to move ${getDisplayNameForRegistrationTeam(team)} from ${currentContestObj.name} to ${newContestObj.name}?`);
                                    if (!hasConfirmed) return;
                                    updateContest(value, team);
                                  }}
                                >
                                  <SelectTrigger className="h-8 text-sm">
                                    <SelectValue placeholder="Select format" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {_.map(selectableContests, (contest) => (
                                      <SelectItem
                                        key={contest._id}
                                        value={contest._id}
                                        disabled={isDeletedEntity(contest)}
                                      >
                                        {entityLabel(contest)}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              </div>
                            </TableCell>
                            {/* Team Info Fields */}
                            {getAllInfoFields().map((fieldName: string) => (
                              <TableCell key={fieldName} className="min-w-24 p-1">
                                {_.get(team, `info.${fieldName}`, '')}
                              </TableCell>
                            ))}
                            <TableCell className="min-w-24 p-1" style={{ maxWidth: '200px'}}>
                              {/* User */}
                              <div>
                                <div className="font-medium truncate" title={_.get(team, 'user.name') || ''}>{`${_.get(team, 'user.name')}`}</div>
                                <div className="text-sm text-muted-foreground truncate" title={_.get(team, 'user.email') || ''}>{getHighlightedText(_.get(team, 'user.email'), searchTerm)}</div>
                              </div>
                            </TableCell>
                            <TableCell className="min-w-24 p-1">
                              {/* Created */}
                              <div className="flex items-center justify-center w-full h-full">
                                {moment(_.get(team, 'created')).format('MM/DD/YYYY hh:mm a')}
                              </div>
                            </TableCell>
                            <TableCell className="min-w-20 p-1">
                              {/* Players / Coaches */}
                              <div className="flex items-center justify-center w-full h-full">
                                <CollapsibleTrigger asChild data-trigger="players-coaches">
                                  <div className="flex items-center justify-center cursor-pointer">
                                    <div className="px-2">{showCoaches ? `${_.get(teamPlayers, 'length')} / ${_.get(team, 'teamManagers', []).length}` : `${_.get(teamPlayers, 'length')}`}</div>
                                    <ChevronDown className="w-4 h-4 text-muted-foreground" />
                                  </div>
                                </CollapsibleTrigger>
                              </div>
                            </TableCell>
                            {/* <TableCell className="min-w-24 p-1" style={{ maxWidth: '200px'}}>
                              <div>
                                <div className="font-medium">{`${_.get(team, 'teamManager1.firstName')} ${_.get(team, 'teamManager1.lastName')}`}</div>
                                <div className="text-sm text-muted-foreground">{getHighlightedText(_.get(team, 'teamManager1.email'), searchTerm)}</div>
                                <div className="text-sm text-muted-foreground">{_.get(team, 'teamManager1.phone')}</div>
                              </div>
                            </TableCell> */}
                            <TableCell className="min-w-24 p-1">
                              { /* Payment (Due + Made + Status consolidated) */ (() => {
                                if (!team.paymentProductId) return <span className="text-muted-foreground">No Payment Product</span>;
                                const dueRaw = Number(calculateTotalPayments2(team, true, teamPlayers));
                                const madeRaw = Number(getTotalPaymentMade(team, true));
                                const status = getPaymentStatusShared(dueRaw, madeRaw, team.hasPaid);
                                const amountColor = status === 'partial' ? 'text-warning'
                                  : status === 'unpaid' ? 'text-destructive' : 'text-success';
                                const remaining = dueRaw - madeRaw;

                                // Build the transaction ledger: each Stripe payment, each
                                // refund (negative-amount doc), and any manual/custom payment.
                                const toCents = (p) => (p.currency || 'usd').toLowerCase() === 'usd'
                                  ? p.amount
                                  : Math.round(p.amount * p.currencyConversionRate);
                                const txns = _.filter(payments, (p) => p.registrationTeam === team._id && !p.donation)
                                  .map((p) => {
                                    const cents = toCents(p);
                                    const email = _.get(p, 'metadata.playerEmail', '');
                                    return {
                                      kind: cents < 0 ? 'refund' : 'payment',
                                      amount: cents,
                                      date: p.paidDate,
                                      forLabel: email ? playerNameByEmail(team, email) : 'Team',
                                      byLabel: payerLabel(p),
                                      discounts: cents < 0 ? [] : discountsForPayment(team, email),
                                      note: null,
                                    };
                                  });
                                if (Number(team.customPaidAmount) > 0) {
                                  txns.push({
                                    kind: 'manual',
                                    amount: Number(team.customPaidAmount) * 100,
                                    date: team.customPaidDate || team.paidDate,
                                    forLabel: 'Team',
                                    byLabel: team.customPaidByName || null,
                                    discounts: [],
                                    note: team.paidNotes,
                                  });
                                }
                                txns.sort((a, b) => new Date(a.date || 0).getTime() - new Date(b.date || 0).getTime());
                                const kindLabel = { payment: 'Payment', refund: 'Refund', manual: 'Manual' };
                                const kindAmountColor = { payment: 'text-success', refund: 'text-destructive', manual: 'text-foreground' };
                                return (
                                  <HoverCard>
                                    <HoverCardTrigger asChild>
                                      <button className="text-left cursor-help">
                                        <div className="flex items-center gap-2">{getPaymentStatus(team, teamPlayers)}</div>
                                        <div className={`font-medium inline-block border-b border-dashed border-muted-foreground/60 ${amountColor}`}>
                                          {convertToUSD(madeRaw)} / {convertToUSD(dueRaw)}
                                        </div>
                                      </button>
                                    </HoverCardTrigger>
                                    <HoverCardContent className="w-96">
                                      <div className="space-y-2">
                                        <h4 className="font-medium leading-none">Transactions</h4>
                                        <div className="space-y-2 text-sm text-muted-foreground">
                                          {txns.length === 0 ? (
                                            <div className="text-xs text-muted-foreground p-1">No payments recorded.</div>
                                          ) : (
                                            txns.map((t, index) => (
                                              <div key={index} className="flex justify-between items-start gap-2 p-2 border rounded">
                                                <div className="min-w-0">
                                                  <div className="text-xs">
                                                    <span className="font-medium text-foreground">{kindLabel[t.kind]}</span>
                                                    <span className="text-muted-foreground/60"> · </span>
                                                    <span>For: {t.forLabel}</span>
                                                  </div>
                                                  {t.byLabel && <div className="text-xs text-muted-foreground">{t.kind === 'manual' ? 'Recorded by' : 'By'}: {t.byLabel}</div>}
                                                  <div className="text-xs text-muted-foreground">{t.date ? moment(new Date(t.date)).format('MM/DD/YYYY h:mm A') : ''}</div>
                                                  {t.discounts.map((d, i) => (
                                                    <div key={i} className="text-xs text-muted-foreground/60">{d}</div>
                                                  ))}
                                                  {t.note && <div className="text-xs text-muted-foreground/60 italic">{t.note}</div>}
                                                </div>
                                                <div className={`font-medium whitespace-nowrap ${kindAmountColor[t.kind]}`}>{convertToUSD(t.amount)}</div>
                                              </div>
                                            ))
                                          )}
                                          <div className="flex justify-between items-center pt-2 border-t">
                                            <div className="font-medium">Total Paid</div>
                                            <div className="font-bold">{convertToUSD(madeRaw)}</div>
                                          </div>
                                          <div className="flex justify-between items-center text-muted-foreground">
                                            <div>Due</div>
                                            <div>{convertToUSD(dueRaw)}</div>
                                          </div>
                                          {remaining > 0 && (
                                            <div className="flex justify-between items-center text-destructive">
                                              <div className="font-medium">Remaining</div>
                                              <div className="font-medium">{convertToUSD(remaining)}</div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </HoverCardContent>
                                  </HoverCard>
                                );
                              })()}
                            </TableCell>
                            <TableCell className="min-w-24 p-1">
                            {filterPaymentsByRegistrationId({ registrationTeamId: team._id , donation: true })}
                            </TableCell>
                            <TableCell>
                              <div className="flex items-center justify-between w-full">
                                {/* Two signals, deliberately both shown: the SELECT is
                                    the admin's stored decision, the badge under it is
                                    the DERIVED capacity state (payment + FIFO). They
                                    are different axes and can legitimately disagree —
                                    e.g. Accepted but not yet paid, so still pending. */}
                                <div className="flex flex-col gap-1 min-w-[140px]">
                                  {/* Radix rejects value="" (it means "clear the
                                      selection"), and Pending IS stored as '' —
                                      so the Select speaks in toSelectValue /
                                      fromSelectValue and the store keeps ''. */}
                                  <Select
                                    value={toSelectValue(team)}
                                    onValueChange={(value) => {
                                      const next = fromSelectValue(value);
                                      if (next === normalizeStatus(team)) return;
                                      handleStatusSelect(next, team);
                                    }}
                                  >
                                    <SelectTrigger className="h-8 text-sm">
                                      <SelectValue placeholder="Status" />
                                    </SelectTrigger>
                                    <SelectContent>
                                      {_.map(REGISTRATION_TEAM_STATUS_OPTIONS, (option) => (
                                        <SelectItem key={toSelectValue(option.value)} value={toSelectValue(option.value)}>
                                          {option.label}
                                        </SelectItem>
                                      ))}
                                    </SelectContent>
                                  </Select>
                                  {(() => {
                                    const divisionId = _.get(team, 'division._id') || _.get(team, 'requestedDivision._id');
                                    const teamDivision = _.find(divisions, (d) => d._id === divisionId);
                                    // Resolve capacity via the shared helper so the
                                    // derivation sees the inherited capacity (the
                                    // division's own is usually the Mongoose default 0).
                                    const effCfg = getEffectiveDivisionConfig(teamDivision);
                                    const teamsInDivision = getRegistrationTeamsForDivision(divisionId, registrationTeams);
                                    const isWaitlisted = effCfg
                                      ? getCapacityState(team, teamsInDivision, effCfg) === 'waitlisted'
                                      : false;
                                    if (!isWaitlisted) return null;
                                    const pos = getWaitlistPosition(
                                      registrationTeams, team._id, divisionId, registrationId,
                                      {
                                        division: effCfg,
                                        getDivisionId: (t) => _.get(t, 'division._id') || _.get(t, 'requestedDivision._id'),
                                        getRegistrationId: (t) => helpers.getObjId(t.registration),
                                      },
                                    );
                                    return (
                                      <Badge variant="outline" className="text-warning border-warning/30 bg-warning/10 w-fit">
                                        Waitlisted #{pos?.position || '?'}
                                      </Badge>
                                    );
                                  })()}
                                </div>
                                {_.get(team, 'config.disableSync') && (
                                  <HoverCard>
                                    <HoverCardTrigger>
                                      <LockIcon className="h-4 w-4 text-warning" />
                                    </HoverCardTrigger>
                                    <HoverCardContent>
                                      <div className="text-sm">
                                        Team sync is disabled - players cannot edit their information
                                      </div>
                                    </HoverCardContent>
                                  </HoverCard>
                                )}
                              </div>
                            </TableCell>
                            <TableCell className="min-w-24 p-1">
                              <IconButton
                                size="small"
                                onClick={(event) => {
                                  setSelectedTeam(team);
                                  setPopoverTrigger(event.currentTarget);
                                  setPopoverOpen(true);
                                }}
                              >
                                <MoreVertical className="h-4 w-4" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          <CollapsibleContent className="w-full" asChild data-content="players-coaches">
                            <>
                              {showCoaches && (
                                <>
                              <div className="flex flex-row">
                                <div>Coaches</div>
                              </div>
                              <TableRow>
                                {_.map([...DEFAULT_MANAGER_FIELDS, ..._.get(registration, 'managerFields', [])], (field) => (
                                  <TableHead className="w-48" key={field.fieldId}>{field.name}</TableHead>
                                ))}
                              </TableRow>
                              {_.map(_.get(team, 'teamManagers', []), (manager) => (
                                <TableRow key={manager._id}>
                                  {_.map(DEFAULT_MANAGER_FIELDS, (field) => {
                                    const v = _.get(manager, field.fieldId);
                                    const isEmail = field.fieldId === 'email';
                                    return (
                                      <TableCell
                                        key={manager._id + field.fieldId}
                                        className={isEmail ? 'max-w-[200px] truncate' : ''}
                                        title={isEmail ? String(v ?? '') : undefined}
                                      >{v}</TableCell>
                                    );
                                  })}
                                  {_.map(_.get(registration, 'managerFields', []), (field) => (
                                    <TableCell key={manager._id + field.fieldId}>{_.get(manager?.info, field.fieldId)}</TableCell>
                                  ))}
                                </TableRow>
                              ))}
                                </>
                              )}
                              <div className="flex flex-row">
                                <div>Players</div>
                              </div>
                              <TableRow>
                                {_.map(_.get(registration, 'fields', []), (field) => (
                                  <TableHead className="w-48" key={field.fieldId}>{field.name}</TableHead>
                                ))}
                                <TableHead className="w-48">Email</TableHead>
                                {teamIsPlayerPay && (
                                  <TableHead className="w-28">Amount Paid</TableHead>
                                )}
                                {_.map(profileFields, (field: any) => (
                                  <TableHead className="w-48" key={`profile-${field.fieldId}`}>{`Profile: ${field.name}`}</TableHead>
                                ))}
                                {_.get(registration, 'playerWaivers', []).length > 0 && (
                                  <TableHead className="w-32">Waiver Status</TableHead>
                                )}
                              </TableRow>
                              {_.map(teamPlayers, (player, index) => {
                                const waiverStatus = getPlayerWaiverStatus(player);

                                return (
                                  <TableRow key={player._id}>
                                    {_.map(_.get(registration, 'fields', []), (field) => (
                                      <TableCell key={player._id + field.fieldId}>
                                        {_.get(player?.info, field.fieldId)}
                                      </TableCell>
                                    ))}
                                    {(() => {
                                      const playerEmail = _.get(player, 'info.email') || player.email || '';
                                      return (
                                        <>
                                          <TableCell className="max-w-[200px] truncate" title={playerEmail}>{playerEmail}</TableCell>
                                          {teamIsPlayerPay && (
                                            <TableCell>{getPlayerAmountPaid(team, playerEmail)}</TableCell>
                                          )}
                                        </>
                                      );
                                    })()}
                                    {(() => {
                                      const up = resolveUserProfile(profileMaps, player);
                                      return _.map(profileFields, (field: any) => {
                                        const v = _.get(up, ['info', field.fieldId]);
                                        return (
                                          <TableCell
                                            key={player._id + 'profile-' + field.fieldId}
                                            className="max-w-[200px] truncate"
                                            title={String(v ?? '')}
                                          >{v}</TableCell>
                                        );
                                      });
                                    })()}
                                    {_.get(registration, 'playerWaivers', []).length > 0 && (
                                      <TableCell>
                                        <div className="flex items-center space-x-2">
                                          {waiverStatus === 'signed' ? (
                                            <div className="flex items-center text-success">
                                              <CheckCircle2 className="h-4 w-4 mr-1" />
                                              <span className="text-sm">Signed</span>
                                            </div>
                                          ) : (
                                            <div className="flex items-center text-warning">
                                              <Clock className="h-4 w-4 mr-1" />
                                              <span className="text-sm">Pending</span>
                                            </div>
                                          )}
                                        </div>
                                      </TableCell>
                                    )}
                                  </TableRow>
                                );
                              })}
                            </>
                          </CollapsibleContent>
                        </>
                      </Collapsible>
                    ) 
                  })}
                </TableBody>
              </Table>
            </div>
            <div className="flex items-center justify-end space-x-2 py-4">
              <div className="flex-1 text-sm text-muted-foreground flex flex-row justify-end">
                <div className="flex flex-column items-center justify-end">Rows per page:</div>
                <div>
                <Select
                  value={rowsPerPage.toString()}
                  onValueChange={(value) => {
                    setRowsPerPage(Number(value));
                    setCurrentPage(1); // Reset to first page when changing rows per page
                  }}
                >
                  <SelectTrigger className="w-20 h-8 ml-2">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="20">20</SelectItem>
                    <SelectItem value="50">50</SelectItem>
                    <SelectItem value="100">100</SelectItem>
                  </SelectContent>
                </Select>
                </div>
              </div>
              <div className="space-x-2 px-8">
                {startPageRange}-{endPageRange > registered.length ? registered.length : endPageRange} of {registered.length}
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => { setCurrentPage(currentPage - 1); }}
                  disabled={!getCanPreviousPage()}
                >
                  Previous
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => { setCurrentPage(currentPage + 1); }}
                  disabled={!getCanNextPage()}
                >
                  Next
                </Button>
              </div>
            </div>

            {/* Free-agent pool (ADR 0054): individual signups awaiting team
                assignment. Hidden entirely when the registration has none.
                Pool rows are selectable; placed rows show their destination. */}
            {freeAgentTeams.length > 0 && (
              <Collapsible open={freeAgentsOpen} onOpenChange={setFreeAgentsOpen} className="mt-6 border-t pt-3">
                <div className="flex items-center justify-between pr-2">
                  <CollapsibleTrigger asChild>
                    <button type="button" className="flex items-center gap-1 text-sm font-medium text-foreground hover:text-foreground transition-colors">
                      <ChevronDown className={`h-3.5 w-3.5 transition-transform ${freeAgentsOpen ? '' : '-rotate-90'}`} />
                      Free Agents ({freeAgentPool.length})
                    </button>
                  </CollapsibleTrigger>
                  <Button
                    size="sm"
                    disabled={selectedFreeAgents.length === 0}
                    onClick={() => setAssignDialogOpen(true)}
                  >
                    Assign to team…
                  </Button>
                </div>
                <CollapsibleContent className="mt-3">
                  <div className="overflow-x-auto rounded-md border">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead className="w-40">
                            <Checkbox
                              aria-label="Select all free agents"
                              checked={freeAgentPool.length > 0 && selectedFreeAgents.length === freeAgentPool.length}
                              onCheckedChange={(checked) => {
                                setSelectedFreeAgents(checked ? _.map(freeAgentPool, (rt) => String(rt._id)) : []);
                              }}
                            />
                          </TableHead>
                          <TableHead>Name</TableHead>
                          <TableHead>Email</TableHead>
                          <TableHead>Preferred Division</TableHead>
                          <TableHead>Payment</TableHead>
                          <TableHead>Created</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {[...freeAgentPool, ...placedFreeAgents].map((rt) => {
                          const players = rt.players || [];
                          const placed = isAccepted(rt);
                          const id = String(rt._id);
                          return (
                            <TableRow key={id} data-testid={`free-agent-row-${id}`}>
                              <TableCell>
                                {placed ? (
                                  <span className="text-xs text-muted-foreground whitespace-nowrap">→ {placedTeamLabel(rt)}</span>
                                ) : (
                                  <Checkbox
                                    aria-label={`Select ${getTeamDisplayName({ name: rt.teamName, players })}`}
                                    checked={selectedFreeAgents.includes(id)}
                                    onCheckedChange={() => toggleFreeAgentSelected(id)}
                                  />
                                )}
                              </TableCell>
                              <TableCell className="font-medium">
                                {/* zqtm_ auto-name → renders the person's name from the players mirror. */}
                                {getTeamDisplayName({ name: rt.teamName, players })}
                              </TableCell>
                              <TableCell>{_.get(rt, 'teamManagers[0].email') || _.get(rt, 'user.email') || '—'}</TableCell>
                              <TableCell>
                                {/* requestedDivision is a PREFERENCE (may be a tombstone — entityLabel suffixes "(deleted)"). */}
                                {entityLabel(_.get(rt, 'requestedDivision')) || 'No preference'}
                              </TableCell>
                              <TableCell>
                                {rt.paymentProductId ? (
                                  <div className="flex items-center gap-1">{getPaymentStatus(rt, players)}</div>
                                ) : (rt.hasPaid || Number(rt.customPaidAmount) > 0) ? (
                                  <Badge variant="outline" className="bg-success/10 text-success border-success/30">Paid</Badge>
                                ) : (
                                  <span className="text-xs text-muted-foreground">No Payment Product</span>
                                )}
                              </TableCell>
                              <TableCell className="whitespace-nowrap text-sm">
                                {rt.created ? moment(rt.created).format('MM/DD/YYYY hh:mm a') : '—'}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </CollapsibleContent>
              </Collapsible>
            )}

            {/* Assign-free-agents dialog: pick a division, then an existing
                DivisionTeam in it OR a brand-new team name (ADR 0054). */}
            <Dialog open={assignDialogOpen} onOpenChange={(open) => { if (!assigning) setAssignDialogOpen(open); }}>
              <DialogContent className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>
                    Assign {selectedFreeAgents.length} player{selectedFreeAgents.length === 1 ? '' : 's'} to a team
                  </DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                  <div className="space-y-1">
                    <Label className="text-sm font-medium">Division</Label>
                    <Select
                      value={assignDivisionId}
                      onValueChange={(value) => {
                        setAssignDivisionId(value);
                        setAssignDivisionTeamId(''); // team list is per-division
                      }}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select a division" />
                      </SelectTrigger>
                      <SelectContent>
                        {_.map(_.orderBy(registrationDivisions, ['name'], ['asc']), (division) => (
                          <SelectItem key={division._id} value={String(division._id)}>
                            {division.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  <div className="flex flex-col space-y-2">
                    <div className="flex items-center space-x-2">
                      <input
                        type="radio"
                        id="assign-existing-team"
                        name="assign-target"
                        checked={assignMode === 'existing'}
                        onChange={() => setAssignMode('existing')}
                        className="h-4 w-4"
                      />
                      <label htmlFor="assign-existing-team" className="text-sm font-medium">Existing team</label>
                    </div>
                    {assignMode === 'existing' && (
                      <div className="ml-6">
                        {(() => {
                          const divisionTeamOptions = _.filter(teamDivisions, (dt) =>
                            String(helpers.getObjId(dt.division)) === String(assignDivisionId));
                          if (!assignDivisionId) {
                            return <p className="text-xs text-muted-foreground">Select a division first.</p>;
                          }
                          if (divisionTeamOptions.length === 0) {
                            return <p className="text-xs text-muted-foreground">No teams in this division yet. Create a new team below.</p>;
                          }
                          return (
                            <Select value={assignDivisionTeamId} onValueChange={setAssignDivisionTeamId}>
                              <SelectTrigger>
                                <SelectValue placeholder="Select a team" />
                              </SelectTrigger>
                              <SelectContent>
                                {_.map(divisionTeamOptions, (dt) => (
                                  <SelectItem key={dt._id} value={String(dt._id)}>
                                    {getTeamDisplayName(dt)}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          );
                        })()}
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col space-y-2">
                    <div className="flex items-center space-x-2">
                      <input
                        type="radio"
                        id="assign-new-team"
                        name="assign-target"
                        checked={assignMode === 'new'}
                        onChange={() => setAssignMode('new')}
                        className="h-4 w-4"
                      />
                      <label htmlFor="assign-new-team" className="text-sm font-medium">New team</label>
                    </div>
                    {assignMode === 'new' && (
                      <div className="ml-6">
                        <input
                          type="text"
                          value={assignNewTeamName}
                          onChange={(e) => setAssignNewTeamName(e.target.value)}
                          placeholder="Team name"
                          className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex justify-end gap-2 pt-2">
                    <Button variant="outline" disabled={assigning} onClick={() => setAssignDialogOpen(false)}>
                      Cancel
                    </Button>
                    <Button
                      disabled={
                        assigning ||
                        selectedFreeAgents.length === 0 ||
                        (assignMode === 'existing'
                          ? !assignDivisionTeamId
                          : !(assignNewTeamName.trim() && assignDivisionId))
                      }
                      onClick={handleAssignFreeAgents}
                    >
                      {assigning ? 'Assigning…' : 'Assign'}
                    </Button>
                  </div>
                </div>
              </DialogContent>
            </Dialog>

            {/* Discreet, default-collapsed section: soft-deleted teams + Restore. */}
            {(() => {
              const deletedInfoFields = _.uniq(_.flatMap(deletedRegistrationTeams, (t) => Object.keys(t?.info || {})));
              return (
                <Collapsible
                  open={deletedOpen}
                  onOpenChange={async (open) => {
                    setDeletedOpen(open);
                    if (open && !deletedLoaded) {
                      setDeletedLoaded(true);
                      const token = await getToken();
                      await getDeletedTeams(registrationId, token);
                    }
                  }}
                  className="mt-6 border-t pt-3"
                >
                  <CollapsibleTrigger asChild>
                    <button type="button" className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors">
                      <ChevronDown className={`h-3.5 w-3.5 transition-transform ${deletedOpen ? '' : '-rotate-90'}`} />
                      Deleted teams{deletedLoaded ? ` (${deletedRegistrationTeams.length})` : ''}
                    </button>
                  </CollapsibleTrigger>
                  <CollapsibleContent className="mt-3">
                    {deletedRegistrationTeams.length === 0 ? (
                      <div className="text-sm text-muted-foreground py-2">No deleted teams.</div>
                    ) : (
                      <div className="overflow-x-auto rounded-md border">
                        <Table>
                          <TableHeader>
                            <TableRow>
                              <TableHead>Team Name</TableHead>
                              <TableHead>Division</TableHead>
                              <TableHead>Format</TableHead>
                              {deletedInfoFields.map((f) => (<TableHead key={f}>{_.startCase(f)}</TableHead>))}
                              <TableHead>User</TableHead>
                              <TableHead>Created</TableHead>
                              <TableHead>{showCoaches ? 'Players / Coaches' : 'Players'}</TableHead>
                              <TableHead>Payment</TableHead>
                              <TableHead>Donation(s)</TableHead>
                              <TableHead>Status</TableHead>
                              <TableHead className="text-right">Action</TableHead>
                            </TableRow>
                          </TableHeader>
                          <TableBody>
                            {deletedRegistrationTeams.map((t) => {
                              const players = t.players || [];
                              const due = calculateTotalPayments2(t, true, players);
                              const made = getTotalPaymentMade(t, true);
                              return (
                                <TableRow key={t._id}>
                                  <TableCell className="font-medium">{getTeamDisplayName({ name: t.teamName, players })}</TableCell>
                                  <TableCell>{entityLabel(t.division) || entityLabel(t.requestedDivision) || '—'}</TableCell>
                                  <TableCell>{entityLabel(t.contest) || entityLabel(t.requestedContest) || '—'}</TableCell>
                                  {deletedInfoFields.map((f) => (<TableCell key={f}>{_.get(t, 'info.' + f, '')}</TableCell>))}
                                  <TableCell>
                                    <div className="font-medium">{t.user?.name}</div>
                                    <div className="text-xs text-muted-foreground">{t.user?.email}</div>
                                  </TableCell>
                                  <TableCell className="whitespace-nowrap text-sm">{t.created ? moment(t.created).format('MM/DD/YYYY hh:mm a') : '—'}</TableCell>
                                  <TableCell>{players.length}{showCoaches ? ` / ${t.teamManagers?.length ?? 0}` : ''}</TableCell>
                                  <TableCell>
                                    {t.paymentProductId ? (
                                      <div className="flex flex-col gap-1">
                                        {getPaymentStatus(t, players)}
                                        <span className="text-xs text-muted-foreground">{convertToUSD(made)} / {convertToUSD(due)}</span>
                                      </div>
                                    ) : (<span className="text-xs text-muted-foreground">No Payment Product</span>)}
                                  </TableCell>
                                  <TableCell>{filterPaymentsByRegistrationId({ registrationTeamId: t._id, donation: true })}</TableCell>
                                  <TableCell>{_.capitalize(t.status) || '—'}</TableCell>
                                  <TableCell className="text-right">
                                    <Button variant="outline" size="sm" onClick={() => setRestoringTeam(t)}>
                                      <RotateCcw className="h-3.5 w-3.5 mr-1" /> Restore
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </div>
                    )}
                  </CollapsibleContent>
                </Collapsible>
              );
            })()}

            <AlertDialog open={!!restoringTeam} onOpenChange={() => setRestoringTeam(null)}>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>Restore team{restoringTeam ? `: ${getTeamDisplayName({ name: restoringTeam.teamName, players: restoringTeam.players || [] })}` : ''}</AlertDialogTitle>
                  <AlertDialogDescription>
                    This team will reappear in the teams list, along with its division and players.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                  <AlertDialogAction
                    onClick={async () => {
                      const team = restoringTeam;
                      setRestoringTeam(null);
                      try {
                        await restoreTeam(registrationId, team._id);
                        await async_getRegistrationTeamsByRegistrationId(registrationId);
                      } catch (e: any) {
                        sonnerToast.error(e?.response?.data?.error || "Failed to restore team.");
                      }
                    }}
                  >
                    Restore Team
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>

            <AlertDialog open={!!refundingTeam} onOpenChange={() => {
              setRefundingTeam(null);
              setSelectedPayments([]);
              setSelectedPayment(null);
              setCustomRefundAmount(null);
            }}>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>Refund Team: {refundingTeam && getDisplayNameForRegistrationTeam(refundingTeam)}</AlertDialogTitle>
                  <AlertDialogDescription>
                    Choose your refund method:
                  </AlertDialogDescription>
                  
                  <div className="mt-4 space-y-4">
                    <div className="flex flex-col space-y-2">
                      <div className="flex items-center space-x-2">
                        <input
                          type="radio"
                          id="payment-select"
                          name="refund-method"
                          checked={refundMethod === 'payments'}
                          onChange={() => setRefundMethod('payments')}
                          className="h-4 w-4"
                        />
                        <label htmlFor="payment-select" className="text-sm font-medium">
                          Select from existing payments
                        </label>
                      </div>
                      
                      {refundMethod === 'payments' && (
                        <div className="ml-6 mt-2">
                          <div className="w-[200px]">
                            <Select
                              value={selectedPayment || ""}
                              onValueChange={(value) => {
                                console.log('selectedPayment:', value);
                                setSelectedPayment(value);
                              }}
                            >
                              <SelectTrigger>
                                <SelectValue placeholder="Select a payment" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="full">Full Refund ({refundingTeam ? convertToUSD(_.sumBy(getTeamPayments(refundingTeam._id), 'totalAmount')) : ''})</SelectItem>
                                {refundingTeam && getTeamPayments(refundingTeam._id).map(({ stripe_payment_intent, totalAmount, initialPaidDate }, i) => (
                                  <SelectItem key={i} value={stripe_payment_intent}>
                                    {convertToUSD(totalAmount)} - {moment(initialPaidDate).format('MM/DD/YYYY')}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col space-y-2">
                      <div className="flex items-center space-x-2">
                        <input
                          type="radio"
                          id="custom-amount"
                          name="refund-method"
                          checked={refundMethod === 'manual'}
                          onChange={() => setRefundMethod('manual')}
                          className="h-4 w-4"
                        />
                        <label htmlFor="custom-amount" className="text-sm font-medium">
                          Enter custom refund amount
                        </label>
                      </div>
                      
                      {refundMethod === 'manual' && (
                        <div className="ml-6 mt-2">
                          <input
                            type="number"
                            value={customRefundAmount || ""}
                            onChange={(e) => {
                              setCustomRefundAmount(Number(e.target.value));
                            }}
                            className="w-full border p-2"
                            placeholder="Enter refund amount"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                  <AlertDialogAction
                    onClick={() => handleRefundTeam(refundingTeam)}
                    className="bg-destructive hover:bg-destructive/90"
                    disabled={
                      (refundMethod === 'payments' && !selectedPayment) ||
                      (refundMethod === 'manual' && (!customRefundAmount || customRefundAmount <= 0))
                    }
                  >
                    Process Refund
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
            <MoveTeamEligibilityDialog
              open={!!pendingDivisionMove}
              teamName={pendingDivisionMove ? getDisplayNameForRegistrationTeam(pendingDivisionMove.team) : ''}
              toDivisionName={pendingDivisionMove?.toDivisionName}
              reasons={pendingDivisionMove?.reasons || []}
              onConfirm={() => {
                if (pendingDivisionMove) updateDivision(pendingDivisionMove.divisionId, pendingDivisionMove.team);
                setPendingDivisionMove(null);
              }}
              onCancel={() => setPendingDivisionMove(null)}
            />
            <AlertDialog open={!!removingTeam} onOpenChange={() => setRemovingTeam(null)}>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>Remove Team: {removingTeam && getDisplayNameForRegistrationTeam(removingTeam)}</AlertDialogTitle>
                  <AlertDialogDescription>
                    Are you sure you want to remove this team? This action cannot be undone.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <div className="grid gap-4 py-4">
                  <div className="flex items-center space-x-4">
                    <Checkbox
                      checked={deleteTeam}
                      onCheckedChange={(checked: boolean | "indeterminate") => setDeleteTeam(checked)}
                    />
                    <Label>Delete Team Data</Label>
                  </div>
                </div>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                  <AlertDialogAction
                    onClick={async () => {
                      try {
                        const removed = removingTeam;
                        await removeTeamRegistration(removed._id, deleteTeam);
                        setRemovingTeam(null);
                        setDeleteTeam(true);
                        await async_getRegistrationTeamsByRegistrationId(registrationId);
                        // Undo toast (sonner — the app's mounted toaster) — instantly
                        // restore the removed team (+ its DivisionTeam) if this was a
                        // misclick. ~20s window.
                        const removedName = getDisplayNameForRegistrationTeam(removed);
                        sonnerToast(`${removedName} removed.`, {
                          duration: 20000,
                          action: {
                            label: "Undo",
                            onClick: async () => {
                              try {
                                await restoreTeam(registrationId, removed._id);
                                await async_getRegistrationTeamsByRegistrationId(registrationId);
                              } catch (e: any) {
                                sonnerToast.error(e?.response?.data?.error || "Failed to undo remove.");
                              }
                            },
                          },
                        });
                      } catch (error) {
                        // Surface the backend reason (e.g. the "fully refund first"
                        // block for a team that still has unrefunded payments).
                        const msg = error?.response?.data?.error || "Failed to remove team. Please try again.";
                        sonnerToast.error(msg);
                      }
                    }}
                    className="bg-destructive hover:bg-destructive/90"
                  >
                    Remove Team
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
            <AlertDialog open={!!consolidatingTeam} onOpenChange={() => !isConsolidating && setConsolidatingTeam(null)}>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>Consolidate Duplicate Teams</AlertDialogTitle>
                  <AlertDialogDescription>
                    {consolidatingTeam && (() => {
                      const info = duplicateInfoByTeamId[String(consolidatingTeam._id)];
                      if (!info) return 'No duplicate found.';
                      const survivor = _.find(info.teams, (t: any) => String(t._id) === info.survivorId);
                      const dupeCount = info.teams.length - 1;
                      return (
                        <>
                          {info.teams.length} entries in this division have the same players:
                          {' '}
                          <strong>{info.teams.map((t: any) => getDisplayNameForRegistrationTeam(t)).join(', ')}</strong>.
                          {' '}
                          They will be merged into the earliest-created team
                          {' '}<strong>{survivor ? getDisplayNameForRegistrationTeam(survivor) : ''}</strong>,
                          combining all payments. The {dupeCount > 1 ? `${dupeCount} duplicates` : 'duplicate'} will be removed. This cannot be undone.
                        </>
                      );
                    })()}
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel disabled={isConsolidating}>Cancel</AlertDialogCancel>
                  <AlertDialogAction
                    disabled={isConsolidating}
                    onClick={async (e) => {
                      e.preventDefault();
                      setIsConsolidating(true);
                      try {
                        await consolidateTeam(consolidatingTeam._id);
                        setConsolidatingTeam(null);
                        await async_getRegistrationTeamsByRegistrationId(registrationId);
                        await async_getPlayersByRegistrationId(registrationId);
                        await async_getPaymentsByRegistrationId(registrationId);
                      } catch (error) {
                        toast({ variant: 'destructive', description: 'Failed to consolidate teams. Please try again.' });
                      } finally {
                        setIsConsolidating(false);
                      }
                    }}
                    className="bg-warning hover:bg-warning/90"
                  >
                    {isConsolidating ? 'Consolidating…' : 'Consolidate'}
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
            <Dialog open={showSettings} onOpenChange={() => setShowSettings(false)}>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Registration Settings</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                  <div className="flex items-center space-x-4">
                    <Switch
                      id="email-reminder"
                      checked={registrationSettings?.emailReminderTeam || false}
                      onCheckedChange={(checked) => {
                        setRegistrationSettings({
                          ...registrationSettings,
                          emailReminderTeam: checked,
                          // Reset numDaysToRemindTeam if disabling email reminders
                          numDaysToRemindTeam: checked ? (registrationSettings?.numDaysToRemindTeam || 7) : null
                        });
                      }}
                    />
                    <Label htmlFor="email-reminder">Enable Email Reminders</Label>
                  </div>
                  
                  <div className="grid grid-cols-6 items-center gap-4">
                    <Label className="col-span-3">Days Before Reminder:</Label>
                    <input
                      type="number"
                      className="col-span-3"
                      disabled={!registrationSettings?.emailReminderTeam}
                      value={registrationSettings?.numDaysToRemindTeam || ''}
                      onChange={(e) => setRegistrationSettings({
                        ...registrationSettings,
                        numDaysToRemindTeam: parseInt(e.target.value) || 0
                      })}
                    />
                  </div>

                  <div className="flex items-center space-x-4">
                    <Switch
                      id="roster-lock"
                      checked={registrationSettings?.rosterLock || false}
                      onCheckedChange={(checked) => {
                        setRegistrationSettings({
                          ...registrationSettings,
                          rosterLock: checked,
                        });
                      }}
                    />
                    <Label htmlFor="roster-lock">Manually Lock Roster Changes</Label>
                  </div>
                  {registrationSettings?.rosterLock && (
                    <div className="text-sm text-warning bg-warning/10 p-3 rounded-md border border-warning/30">
                      ⚠️ Warning: This will immediately lock all roster changes. Teams will no longer be able to add, remove, or modify players.
                    </div>
                  )}
                  
                  <div className="grid grid-cols-6 items-center gap-4">
                    <Label className={`col-span-3 ${registrationSettings?.rosterLock ? 'text-muted-foreground/60' : ''}`}>
                      Roster Lock Date:
                    </Label>
                    <input
                      type="date"
                      className={`col-span-3 ${registrationSettings?.rosterLock ? 'bg-muted text-muted-foreground/60 cursor-not-allowed' : ''}`}
                      disabled={registrationSettings?.rosterLock}
                      value={registrationSettings?.rosterLockDate ? new Date(registrationSettings.rosterLockDate).toISOString().split('T')[0] : ''}
                      onChange={(e) => setRegistrationSettings({
                        ...registrationSettings,
                        rosterLockDate: e.target.value ? new Date(e.target.value).toISOString() : null
                      })}
                    />
                  </div>
                </div>
                <div className="flex justify-end gap-4">
                  <Button variant="outline" onClick={() => setShowSettings(false)}>
                    Cancel
                  </Button>
                  <Button onClick={updateRegistrationSettingsFunction}>
                    Save Changes
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
            
            {/* Single Popover for team actions */}
            <Popover open={popoverOpen} onOpenChange={(open) => {
              setPopoverOpen(open);
              if (!open) {
                setPopoverTrigger(null);
                setSelectedTeam(null);
              }
            }}>
              <PopoverContent className="w-48 p-0" style={{
                position: 'fixed',
                top: popoverTrigger ? popoverTrigger.getBoundingClientRect().bottom + 5 : 0,
                left: popoverTrigger ? popoverTrigger.getBoundingClientRect().left : 0,
              }}>
                <div className="flex flex-col">
                  {/* Row-specific team editing lives on /admin/team/:teamId, which
                      takes the DIVISION TEAM id. This used to be two items: a
                      "View Team" link here and an "Edit Registration Team" link to
                      the registration's teams LIST (which carried no row id, so it
                      edited nothing). Merged into one correctly-labelled item. */}
                  {helpers.getObjId(selectedTeam?.divisionTeam) && (
                    <Link
                      to={`/admin/team/${helpers.getObjId(selectedTeam?.divisionTeam)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer"
                      onClick={() => {
                        setPopoverOpen(false);
                        setPopoverTrigger(null);
                        setSelectedTeam(null);
                      }}
                    >
                      Edit Registration Team
                    </Link>
                  )}
                  <button
                    onClick={() => {
                      setRefundingTeam(selectedTeam);
                      const paymentMade = filterPaymentsByRegistrationId({
                        registrationTeamId: selectedTeam._id,
                        donation: false,
                        raw: true
                      });
                      setRefundAmount(Number(paymentMade) / 100); // Convert cents to dollars
                      setPopoverOpen(false);
                      setPopoverTrigger(null);
                      setSelectedTeam(null);
                    }}
                    disabled={!filterPaymentsByRegistrationId({ registrationTeamId: selectedTeam?._id, donation: false, raw: true })}
                    className="flex items-center px-3 py-2 text-sm text-destructive hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Refund Team
                  </button>
                  {/* Promote/Move-to-Waitlist buttons removed: capacity state is
                      derived (see packages/shared/utils/waitlist.ts), not an
                      admin override. Auto-promotion happens via the cron when
                      a team is removed or a grace window expires. */}
                  {selectedTeam && duplicateInfoByTeamId[String(selectedTeam._id)] && (
                    <button
                      onClick={() => {
                        setConsolidatingTeam(selectedTeam);
                        setPopoverOpen(false);
                        setPopoverTrigger(null);
                        setSelectedTeam(null);
                      }}
                      className="flex items-center px-3 py-2 text-sm text-warning hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer"
                    >
                      Consolidate Duplicate
                    </button>
                  )}
                  <button
                    onClick={() => {
                      setRemovingTeam(selectedTeam);
                      setPopoverOpen(false);
                      setPopoverTrigger(null);
                      setSelectedTeam(null);
                    }}
                    className="flex items-center px-3 py-2 text-sm text-destructive hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer"
                  >
                    Remove Team
                  </button>
                </div>
              </PopoverContent>
            </Popover>
          </div>
        </div>
      </div>
    </section>
    </PageContainer>
  );
}

function LockIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  )
}

function CheckIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}

function AlertCircleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  )
}

export default RegistrationAdmin;
